// i18n.de.js — słownik NIEMIECKI (MONIT 2026-10-02_0526; dobór tłumaczeń: Claude, zgoda
// Martina z góry, korekty w kolejnych iteracjach). Styl: bezosobowo i krótko, jak na
// tabliczce maszyny; zwrot do osoby „du". Prawdziwe umlauty i ß, UTF-8, bez długiego myślnika
// (w DE zastępujemy go przecinkiem / kropką / dwukropkiem). Terminy branżowe zostają:
// Brandschutz, Leitungsweg, Gebäude, Keller, Treppenhaus, APL, HÜP, GV, SP, TA, WE, KND, EG/OG/KG/DG.
// Nazwy slotów zgodne z protokołem NE4 w Zinier FSM (PODRECZNIK_FSM_NE4, Projekt Tablet-FSM):
// „Gf-TA geöffnet", „Gf-TA geschlossen mit Home-ID", „Dämpfungsmessung", „Rotlicht-Test",
// „HÜP geöffnet", „Spleißkassette", „HÜP Beschriftung Home-ID".
// Klucze = i18n.pl.js (test parzystości). Liczba mnoga: { one, other }.
/* eslint-disable quotes */

export const DE = {
  // ─── wspólne ──────────────────────────────────────────────────────────────
  'common.cancel': 'Abbrechen',
  'common.ok': 'OK',
  'common.close': 'Schließen',
  'common.back': 'Zurück',
  'common.save': 'Speichern',
  'common.change': 'Ändern',
  'common.delete': 'Löschen',
  'common.retry': 'Erneut versuchen',
  'common.yes': 'Ja',
  'common.no': 'Nein',
  'common.loading': 'Wird geladen…',
  'common.saving': 'Wird gespeichert…',
  'common.refresh': 'Aktualisieren',
  'common.understood': 'Verstanden',
  'common.tryAgain': 'Bitte erneut versuchen.',
  'common.unknown': 'unbekannt',
  'common.none': 'keine',

  // ─── język / motyw ────────────────────────────────────────────────────────
  'lang.toggleAria': 'Sprache umschalten (PL / DE)',
  'lang.toggleTitle': 'Sprache / Język',
  'theme.toLightAria': 'Auf helles Design umschalten',
  'theme.toDarkAria': 'Auf dunkles Design umschalten',
  'theme.lightTitle': 'Helles Design',
  'theme.darkTitle': 'Dunkles Design',
  'theme.dark': 'Dunkel',
  'theme.light': 'Hell',

  // ─── App.jsx ──────────────────────────────────────────────────────────────
  'app.notFound': '404, Seite nicht gefunden',
  'app.backHome': 'Zur Startseite',

  // ─── netErrors.js ─────────────────────────────────────────────────────────
  'net.offline': 'Keine Verbindung. Die Änderung wurde nicht gespeichert, bitte bei besserem Empfang erneut versuchen.',
  'net.saveFailed': 'Speichern fehlgeschlagen',
  'net.failedWithCode': '{action} ({code}). Bitte erneut versuchen.',
  'net.failedPlain': '{action}. Bitte erneut versuchen.',
  'err.duplicate_photo': 'Dieses Foto ist bereits in einem anderen Slot dieser Adresse (Duplikat).',
  'err.image_too_small': 'Foto zu klein (min. 1000 px und 50 KB). Neues Foto mit der Kamera aufnehmen, nicht aus der Vorschau.',
  'err.forbidden': 'Diese Adresse ist einem anderen Team zugeordnet. Martin anrufen, er gibt die Adresse frei.',
  'err.forbidden_support_role': 'Das Servicekonto hat keine Berechtigung für diese Aktion.',
  'err.admin_cannot_configure': 'Das Ansichtskonto kann keine Daten ändern.',
  'err.slot_not_found': 'Slot existiert nicht (Ansicht aktualisieren).',
  'err.photo_not_found': 'Foto existiert nicht mehr (Ansicht aktualisieren).',
  'err.not_found': 'Nicht gefunden (Ansicht aktualisieren).',
  'err.unauthorized': 'Sitzung abgelaufen. Bitte erneut anmelden.',

  // ─── uploadErrors.js ──────────────────────────────────────────────────────
  'upErr.image_too_small': 'Foto abgelehnt: verkleinerte Kopie (Vorschau aus Galerie/Messenger). Minimum: lange Seite 1000 px und 50 KB. Original in voller Auflösung wählen.',
  'upErr.duplicate_photo': 'Foto abgelehnt: DUPLIKAT, dieselbe Datei ist bereits im System.',
  'upErr.address_not_found': 'Adresse außerhalb des Upload-Wochenfensters oder einem anderen Team zugeordnet. Wenn es deine Adresse ist: im Büro melden (KW-Fenster).',
  'upErr.forbidden': 'Adresse gehört einem anderen Team, Upload gesperrt.',
  'upErr.forbidden_support_role': 'Das Servicekonto kann an dieser Adresse keine Fotos hochladen.',
  'upErr.address_missing_or_invalid_ausbauTermin': 'Adresse hat keinen gültigen Ausbau Termin in Airtable, im Büro melden.',
  'upErr.address_missing_team': 'Adresse hat kein Team in Airtable, im Büro melden.',
  'upErr.address_no_projekt_link': 'Adresse hat kein Projekt in Airtable, im Büro melden.',
  'upErr.file_too_large': 'Datei zu groß (Limit 20 MB).',
  'upErr.offline': 'Kein Internet, das Foto wartet in der Warteschlange und wird bei Empfang automatisch gesendet.',
  'upErr.server': 'Serverfehler, bitte gleich erneut versuchen.',
  'upErr.serverWithCode': '{server} (Code: HTTP {status})',
  'upErr.unknown': 'Foto abgelehnt (Code: {code}). Erneut versuchen; wenn es sich wiederholt, diesen Code an Martin geben.',
  'photo.tooSmall': 'Das ist eine verkleinerte Kopie des Fotos (z. B. aus einem Messenger). Original in voller Auflösung wählen.',

  // ─── formatSyncResult.js ──────────────────────────────────────────────────
  'sync.noResult': 'OneDrive: kein Ergebnis',
  'sync.held': '⛔ Sync angehalten: {n} Slot(s) ohne KI-Freigabe, rote/graue Kacheln prüfen',
  'sync.withErrors': 'OneDrive ⚠ kopiert {synced}/{total}, Fehler: {errs}',
  'sync.allDoneLink': '✅ Alles bereits auf OneDrive, Ordnerlink ergänzt',
  'sync.allDone': '✅ Alles bereits mit OneDrive synchronisiert',
  'sync.copied': '✅ OneDrive: kopiert {synced}/{total}',
  'sync.queued': '⏳ In der OneDrive-Warteschlange{pos}',
  'sync.queuedPos': ' (Position {pos})',
  'sync.running': '🔄 Kopieren… {copied}{total}',
  'sync.failed': '❌ Fehler bei {copied}{total}: {error}',

  // ─── appVersion.js (baner wersji) ─────────────────────────────────────────
  'ver.ready': '🔄 Neue Version bereit{t}',
  'ver.downloading': '⬇ Neue Version wird geladen{t}{p}, wird bei Empfang fertig',
  'ver.required': 'Update erforderlich{t}. Die Dateien sind schon auf dem Handy, ein Tipp genügt.',
  'ver.requiredPartial': '⚠ Update erforderlich{t}{p}, bei Empfang abschließen. Du kannst weiterarbeiten.',

  // ─── queueHealth.js (stopka kolejki) ──────────────────────────────────────
  'queue.photos': { one: 'Foto', other: 'Fotos' },
  'queue.lastSent': 'zuletzt gesendet {ago}',
  'queue.nothingSent': 'noch nichts gesendet',
  'queue.waiting': '⏳ {total} {photos} wartet{f} · {tail}',
  'queue.allSentAgo': '✓ alles gesendet · zuletzt {ago}',
  'queue.allSent': '✓ alles gesendet',

  // ─── useApi.js ────────────────────────────────────────────────────────────
  'api.noLocalData': 'Keine lokalen Daten für diese Adresse. Synchronisierung einschalten oder die Adresse bei Empfang öffnen.',
  'api.weakSignal': 'Schwacher Empfang: Der Server hat in 6 s nicht geantwortet. Bei besserem Empfang erneut versuchen.',

  // ─── weTypeSheet.js / bsCodes.js (etykiety typów i slotów BS) ─────────────
  'weType.t1.label': 'Typ-1 (Leerrohre)',
  'weType.t1.desc': 'Leerrohre aus dem Keller, im Treppenhaus Revisionsöffnung, per Leerrohr in die Wohnung.',
  'weType.t2.label': 'Typ-2 (Schacht)',
  'weType.t2.desc': 'Kabel aus der Wohnung durch den Schacht nach unten in den Keller.',
  'weType.t3.label': 'Typ-3 (Decke)',
  'weType.t3.desc': 'Zuführung aus der Wohnung darunter durch den Boden, weiter nach oben durch die Decke.',
  'weType.t4_r.label': 'Typ-4 (R-WE)',
  'weType.t4_r.desc': 'Revisionsöffnung zur Wohnung: Kanal von der Revisionsöffnung durch die Wand in die Wohnung, ohne Deckendurchbruch.',
  'weType.t4_s.label': 'Typ-4 (S-WE)',
  'weType.t4_s.desc': 'Deckendurchbruch im Treppenhaus zur Wohnung: Kanal im Treppenhaus mit Deckendurchbruch auf dieser Etage, durch die Wand in die Wohnung.',
  'weType.f.label': 'F (Fassade)',
  'weType.f.desc': 'Kabel von außen durch die Außenwand in die Wohnung.',
  'weType.unknown': 'nicht festgelegt',
  'weType.unknownDesc': 'Wohnungstyp nicht festgelegt (Adresse T5): Typ über „Ändern" wählen.',
  'weType.okKeep': 'OK, {type} behalten',
  'weType.changeQuestion': 'Typ von {from} auf {to} ändern?',
  'weType.changedToast': 'WE-Typ geändert auf {to}, Slots neu aufgebaut',
  'weType.saveFailed': 'Typ konnte nicht gespeichert werden.',
  'weType.convertDialog': 'Die Adresse wechselt auf die neuen Regeln (v2): alte Slots werden zugeordnet, Fotos bleiben erhalten. Fortfahren?',
  'weType.v1Locked': 'Adresse nach alten Regeln, den Typ ändert der Admin',
  'weType.readonly': 'Das Ansichtskonto kann den Wohnungstyp nicht ändern',
  'weType.ackBack': 'Verstanden, zurück zu {type}',
  'weType.previous': 'vorheriger Typ',
  'lock.rules_v1_locked': 'Die Adresse läuft nach alten Regeln (Montage vor KW37). Der Typ kann nicht geändert werden. Martin kontaktieren, er schaltet die Adresse auf die neuen Regeln um.',
  'lock.t5_locked': 'Dieser Typ kann nicht gespeichert werden. Martin kontaktieren, er schaltet ihn für dich frei.',
  'lock.slot_automatic': 'Dieser Durchbruch ergibt sich aus dem Wohnungstyp (t3 auf der untersten Etage). Er verschwindet von selbst nach Änderung des WE-Typs und lässt sich nicht manuell löschen.',
  'lock.slot_has_photos': 'Dieser Slot hat bereits Fotos. Löschen kann ihn nur der Admin (Martin kontaktieren).',
  'lock.bs_kd_required': 'BS-KD (Hauptdurchbruch) existiert immer und lässt sich nicht löschen.',
  'lock.admin_cannot_configure': 'Das Ansichtskonto kann weder Typ noch Slots ändern.',
  'lock.forbidden': 'Diese Adresse ist einem anderen Team zugeordnet. Martin anrufen, er gibt die Adresse frei.',
  'lock.invalid_fed_from': 'Die angegebene zuführende Wohnung existiert eine Etage tiefer nicht. Andere aus der Liste wählen.',
  'lock.config_not_found': 'Die Adresse hat noch keine Gebäudekonfiguration. Zuerst den Assistenten speichern.',
  'lock.default': 'Speichern fehlgeschlagen ({code}). Erneut versuchen oder Martin kontaktieren.',
  'lock.errorWord': 'Fehler',

  'addrType.T1.label': 'Typ-1 (Leerrohre)',
  'addrType.T1.desc': 'Leerrohre aus dem Keller, Kabel wird Etage für Etage durchgeschoben; im Treppenhaus Revisionsöffnung mit Abzweig zu den Wohnungen, in den Rohröffnungen Brandschutzwolle.',
  'addrType.T2.label': 'Typ-2 (Schacht)',
  'addrType.T2.desc': 'Durchbruch vom Keller in den Schacht (BS-KD); aus jeder Wohnung wird das Kabel durch den Schacht nach unten geführt, in jeder WE ein Durchbruch zum Schacht; auf den Etagen nichts.',
  'addrType.T3.label': 'Typ-3 (Decke)',
  'addrType.T3.desc': 'Durchbruch vom Keller direkt in die Wohnung (BS-KD); weiter Decke WE → Boden WE darüber, Steigleitung durch die Wohnungen; auf den Etagen nichts.',
  'addrType.T4.label': 'Typ-4 (Treppe)', // kafelek rzędu typów 54 px: „Treppenhaus" ucinało się (zrzut 360 px)
  'addrType.T4.desc': 'Durchbruch vom Keller ins Treppenhaus (BS-KD); Metallkanäle im Treppenhaus, Deckendurchbruch im Treppenhaus auf jeder Etage, vom Treppenhaus durch die Wand in die WE.',
  'addrType.T5.label': 'Typ-5 (Gemischt)',
  'addrType.T5.desc': 'Fassade oder Mischform (z. B. linker Teil Schacht, rechter Teil Treppenhaus): jede WE wird einzeln konfiguriert, F (Fassade) nur pro WE; mehrere Durchbrüche aus dem Keller möglich (BS+).',

  'bs.bs_kd': 'BS-KD · Durchbruch aus dem Keller (APL → Gebäude)',
  'bs.bs_rv': 'BS-RV · Revision im Treppenhaus (Wolle in den Leerrohren)',
  // MONIT 2026-10-02_1353 (pakiet v77) zad. 2: Pfeil beginnt beim Techniker und zeigt, wohin der Durchbruch führt.
  'bs.bs_th_b': 'BS-THb · Brandschott Treppenhaus → Etage darunter (Boden)',
  'bs.bs_th_d': 'BS-THd · Brandschott Treppenhaus → Etage darüber (Decke)',
  'bs.bs_we_w': 'BS-WEw · Brandschott Wohnungswand', // MONIT 2026-10-02_1112 (pakiet-etykiety-ikona-kafelki) zad. 2: wersja ogólna; per typ: bs.bs_we_w.<typ>
  'bs.bs_we_b': 'BS-WEb · Brandschott Wohnung → Wohnung darunter (Boden)',
  'bs.bs_we_d': 'BS-WEd · Brandschott Wohnung → Wohnung darüber (Decke)',
  'bs.kdOf': 'BS-KD ({n} von {total})',
  'slot.entfallen': 'Für diese Adresse nicht nötig',
  'slot.entfallenKept': '{label} · Fotos erhalten ({n})',

  // ─── etykiety slotów (klucz = slot_key; warstwa wyświetlania) ────────────
  'slot.ta_offen': 'Gf-TA geöffnet',
  'slot.ta_zu_qr': 'Gf-TA geschlossen mit QR-Code',
  'slot.ta_zu_qr_knd': 'QR-Code mit Kabel',
  'slot.leitungsweg': 'Leitungsweg', // ohne Kontext (Fallback); v79: Variante nach Ort unten
  // v79 (MONIT 2026-10-03_1200 zad. 2): Leitungsweg nach Ort
  'slot.leitungsweg.we': 'Leitungsweg in der Wohnung zur Gf-TA',
  'slot.leitungsweg.we.t4': 'Leitungsweg in der Wohnung · Treppenhauswand → Gf-TA',
  'slot.leitungsweg.we.t1': 'Leitungsweg in der Wohnung · Leerrohr → Gf-TA',
  'slot.leitungsweg.we.t2': 'Leitungsweg in der Wohnung · Kaminschacht → Gf-TA',
  'slot.leitungsweg.we.t3': 'Leitungsweg in der Wohnung · Steigleitung → Gf-TA',
  'slot.leitungsweg.we.f': 'Leitungsweg in der Wohnung · Fenster → Gf-TA',
  'slot.leitungsweg.floor': 'Leitungsweg im Treppenhaus · {floor}',
  'slot.leitungsweg.kg': 'Leitungsweg im Keller · APL → Deckendurchbruch',
  'slot.ta_messung': 'Dämpfungsmessung',
  'slot.ta_name': 'Namensschild',
  'slot.ta_zd': 'Gesamtansicht',
  'slot.brandschutz': 'Brandschutz',
  'slot.laser_test': 'Rotlicht-Test (Laser)',
  'slot.lsweg_conn': 'Leitungsweg zu diesem Gebäudeteil: Kanal, Rohr', // Plan posesji B0 (MONIT 2026-10-03_1200 zad. 3)
  'slot.knd_ablage': 'Ablageort Kabel', // pakiet v78 (MONIT 2026-10-02_2226 zad. 2)

  // ─── MusterGallery.jsx ────────────────────────────────────────────────────
  'muster.title': 'MUSTERFOTO',
  'muster.must': '✓ MUSS AUF DEM FOTO SEIN',
  'muster.errs': '✗ HÄUFIGE FEHLER',
  'muster.noEntry': 'Das Muster für diesen Slot folgt in der nächsten Muster-Runde.',
  'muster.closeAria': 'Muster schließen',
  'muster.imgAlt': 'Muster: {name}',
  'muster.assetServer': '{key} (Server)',
  'muster.assetLabel': 'Asset: {asset}',
  'muster.source': 'Quelle: freigegebenes Foto → Zeichnung',
  'muster.uploading': '⏳ Wird hochgeladen…',
  'muster.replace': '🖼 Grafik ersetzen (Galerie) · ADMIN',
  'muster.footerTech': 'Referenzfenster, Muster bearbeiten nur im ADMIN-Modus',
  'muster.replaced': 'Grafik ersetzt ✓ (Version v{version}), sofort aktiv, ohne Build.',
  'muster.replaceFailed': 'Grafik konnte nicht ersetzt werden',

  // ─── configErrors.js (wizard) ─────────────────────────────────────────────
  'cfgErr.otherTeam': 'Diese Adresse ist einem anderen Team zugeordnet. Das ist kein App-Fehler, sondern Verfahren: Martin anrufen, er gibt die Adresse frei.',
  'cfgErr.saveFailed': 'Konfiguration konnte nicht gespeichert werden',
  'cfgErr.viewerCannot': 'Das Ansichtskonto kann das Gebäude nicht konfigurieren.',
  'cfgErr.teamCodeMissing': 'Team_Code in Airtable nicht ausgefüllt, bei Martin melden.',
  'cfgErr.wouldDeleteSlots': 'Speichern nicht möglich: Die Änderung würde Slots mit hochgeladenen Fotos entfernen. Fotos löschen wir nicht, Martin anrufen.',
  'cfgErr.rulesV1Locked': 'Die Adresse läuft nach alten Regeln (Montage vor KW37). Der Typ kann nicht geändert werden. Martin kontaktieren, er schaltet die Adresse auf die neuen Regeln um und gibt den Typ frei.',
  'cfgErr.t5Locked': 'Dieser Typ kann nicht gespeichert werden. Martin kontaktieren, er schaltet ihn für dich frei.',
  'cfgErr.resetFailed': 'Zurücksetzen fehlgeschlagen',
  'cfgErr.resetForbidden': 'Nur Techniker oder Admin dürfen zurücksetzen, Berechtigungen prüfen.',
  'cfgErr.resetReason': 'Kurzen Grund für das Zurücksetzen angeben (min. 3 Zeichen).',
  'cfgErr.blockedN': 'Speichern gesperrt: Die Änderung würde {n} Fotos in Slots entfernen: {lista}.',
  'cfgErr.cannotSaveN': 'Speichern nicht möglich: Die Änderung würde {n} Fotos in Slots entfernen: {lista}. Fotos löschen wir nicht. Wenn die Konfiguration wirklich geändert werden muss, Martin anrufen.',

  // ─── erklaerungErrors.js (dokument zgody) ────────────────────────────────
  'erkErr.GRUENDE_MISSING': 'Mindestens einen Grund der abweichenden Montage ankreuzen.',
  'erkErr.GRUND_UNKNOWN': 'Unbekannter Grund, App aktualisieren und erneut versuchen.',
  'erkErr.GRUND_ANDERER_TEXT_MISSING': 'Die Position „Anderer Grund" braucht eine kurze Beschreibung.',
  'erkErr.GRUND_ANDERER_TEXT_TOO_LONG': 'Beschreibung „Anderer Grund" zu lang, maximal 90 Zeichen, eine Zeile.',
  'erkErr.POSITION_TOO_LONG': 'Beschreibung der Montageposition zu lang, maximal 160 Zeichen (2 Zeilen).',
  'erkErr.MISSING_VORNAME': 'Vornamen des Kunden angeben.',
  'erkErr.SIGNATURE_MISSING': 'Unterschrift fehlt, den Kunden um Unterschrift im Rahmen bitten.',
  'erkErr.SIGNATURE_EMPTY': 'Unterschrift leer oder zu schwach, den Kunden um erneute Unterschrift bitten.',
  'erkErr.SIGNATURE_TOO_SMALL': 'Unterschrift zu klein, den Kunden um eine große Unterschrift über den ganzen Rahmen bitten.',
  'erkErr.SIGNATURE_BAD': 'Unterschrift wurde nicht korrekt gespeichert, Rahmen leeren und erneut versuchen.',
  'erkErr.SIGNATURE_TOO_BIG': 'Unterschrift zu groß, Rahmen leeren und erneut unterschreiben.',
  'erkErr.address_missing_kw': 'Adresse hat keinen Ausbau Termin in Airtable, im Büro melden, das Dokument wartet.',
  'erkErr.address_missing_street': 'Adresse hat keine Straße/Hausnummer in Airtable, im Büro melden.',
  'erkErr.address_missing_team': 'Adresse hat kein Team, im Büro melden, das Dokument wartet.',
  'erkErr.address_not_found': 'Adresse nicht gefunden, Aufgabenliste aktualisieren.',
  'erkErr.airtable_error': 'Airtable antwortet gerade nicht, gleich erneut versuchen.',
  'erkErr.admin_cannot_sign': 'Das Ansichtskonto kann keine Dokumente ausstellen, das Dokument unterschreibt der Kunde beim Techniker.',
  'erkErr.forbidden': 'Diese Adresse gehört einem anderen Team.',
  'erkErr.sidecar_unreachable': 'Der Dokumentgenerator ist nicht erreichbar, in 1 bis 2 Minuten erneut versuchen.',
  'erkErr.sidecar_bad_payload': 'Der Generator hat ein beschädigtes Dokument geliefert, erneut versuchen; wenn es sich wiederholt, im Büro melden.',
  'erkErr.storage_error': 'Datei konnte nicht auf dem Server gespeichert werden, erneut versuchen.',
  'erkErr.db_error': 'Datenbankfehler, erneut versuchen.',
  'erkErr.db_insert_failed': 'Fehler beim Schreiben in die Datenbank, das Dokument wurde NICHT gespeichert, erneut versuchen.',
  'erkErr.offline': 'Die Einverständniserklärung braucht eine Internetverbindung: Das PDF erzeugt der Server, der Kunde unterschreibt sofort. Zurück in den Empfang (z. B. vor das Gebäude) und erneut versuchen.',
  'erkErr.generateFailed': 'Dokument konnte nicht erzeugt werden{status}, erneut versuchen.',

  // ─── drobne helpery ───────────────────────────────────────────────────────
  'photo.rejectedDefault': 'manuell vom Büro abgelehnt',
  'upload.notSentNof': 'Nicht gesendet {failed} von {total}: {names}',
  'settings.noLimit': 'ohne Begrenzung',
  'settings.kw': '{v} KW',
  'settings.backForward': '{back} zurück · {forward} voraus',
  'settings.on': 'eingeschaltet',
  'settings.offUpper': 'AUSGESCHALTET',
  'weeks.pick': 'Woche wählen',
  'weeks.pickKw': 'KW wählen',
  'weeks.nWeeks': '{n} Wochen',
  'queue.local': '🔒 Lokaler Modus · {total} {photos} auf dem Handy',
  'queue.failedN': { one: 'fehlgeschlagen', other: 'fehlgeschlagen' },
  'queue.failedSuffix': ' ({failed} {word})',
  'ago.s': 'vor {n} s',
  'ago.min': 'vor {n} min',
  'ago.h': 'vor {n} Std.',
  'ago.d': 'vor {n} Tagen',
  'settings.until': 'bis {ts}',
  'settings.indefinite': 'unbefristet',
  'erkErr.MISSING_NACHNAME': 'Nachnamen des Kunden angeben.',
  'upload.noName': 'ohne Namen',
  'cfg.photosAbbr': '{n} Fotos',

  // ─── TaskListScreen.jsx ───
  'tasks.status.empty': 'Offen',
  'tasks.status.active': 'In PWA 🟢',
  'tasks.status.blocked': 'Gesperrt 🔒',
  'tasks.status.completed': 'Abgeschlossen ✅',
  'tasks.continue': 'Weiter',
  'tasks.start': 'Starten',
  'tasks.blockedBadge': 'Gesperrt',
  'tasks.adminBtn': '🔧 Admin',
  'tasks.pending': 'Ausstehend',
  'tabs.tasks': 'Aufgaben',
  'tabs.map': 'Karte',
  'tabs.settings': 'Einstellungen',
  'tasks.plannedInstall': 'Geplante Montage',
  'tasks.mapSoon': 'Karte: demnächst 🗺️',
  'tasks.queueChipTitle': '{n} Fotos warten auf Versand',
  'tasks.serwisThisPhone': 'Service: dieses Handy',
  'auth.logout': 'Abmelden',
  'tasks.offlineList': '⚠ Offline, letzte Liste vom Handy',
  'tasks.staleWeek': '📅 KW {kw}, nicht die aktuelle Woche',
  'tasks.currentWeekBtn': '→ Aktuelle Woche',
  'tasks.loading': 'Aufgaben werden geladen…',
  'tasks.refreshing': '⟳ Wird aktualisiert…',
  'tasks.noAddresses': 'Keine Adressen in dieser Woche für Team {team}.',
  'tasks.checkOtherWeeks': 'Andere Wochen über den Button unten prüfen.',
  'tasks.otherWeeks': 'Andere Wochen',
  'tasks.billing': '💶 Abrechnung',
  'tasks.billingSoon': 'Abrechnung: Modul in Vorbereitung 💶',
  'settings.title': 'EINSTELLUNGEN',
  'settings.theme': 'Design',
  'settings.language': 'Sprache / Język',

  // ─── LoginScreen.jsx ───
  'login.adminPrompt': 'Admin-PIN eingeben',
  'login.teamPrompt': 'Team-PIN eingeben',
  'login.dbUnavailable': 'Datenbank nicht erreichbar, in einer Minute erneut versuchen',
  'login.invalidPin': 'Ungültige PIN',
  'login.clearAria': 'Löschen',
  'login.backspaceAria': 'Zurück',
  'login.loggingIn': 'Anmeldung…',
  'login.submit': 'Anmelden',
  'login.logoTitle': '5× tippen (oder 3 s halten) = Codefeld',
  'login.admin': 'Admin',

  // ─── AdminTaskListScreen.jsx ───
  'months.short': 'Jan,Feb,Mär,Apr,Mai,Jun,Jul,Aug,Sep,Okt,Nov,Dez',
  'admin.administrator': 'Administrator',
  'admin.windowBadge': 'Fenster: {v}',
  'admin.allKw': 'alle KW',
  'admin.serwisTitle': 'Servicepanel: Systemeinstellungen',
  'admin.serwis': '🛠 Service',
  'admin.allAssignedTeams': 'Alle zugeordneten Teams',
  'admin.allTeams': 'Alle Teams',
  'admin.loadingTeams': 'Teams werden geladen…',
  'admin.pickTeam': 'Team wählen…',
  'admin.teamAria': 'Teamauswahl',
  'admin.allProjects': 'Alle Projekte',
  'admin.pickProject': 'Projekt wählen…',
  'admin.projectAria': 'Projektauswahl',
  'admin.kwUnsetSub': 'Woche offen, Planung',
  'admin.currentWeek': '(aktuell)',
  'admin.pickWeek': 'Woche wählen…',
  'admin.weekAria': 'Wochenauswahl',
  'admin.resetFiltersTitle': 'Filter zurücksetzen: aktuelle KW + alle Teams',
  'admin.resetFilters': 'Filter zurücksetzen',
  'admin.summary': 'Übersicht',
  'admin.allTeamsLower': 'alle Teams',
  'admin.projectWord': 'Projekt',
  'admin.inProgress': 'In Arbeit',
  'admin.perTeam': 'Pro Team (WE · TA · Vorb. · in Arbeit)',
  'admin.pickKwToSee': 'KW wählen, um Adressen zu sehen',
  'admin.noAddressesIn': 'Keine Adressen in {range}{team}.',
  'admin.forTeam': ' für Team {team}',
  'admin.syncBar': '☁ OneDrive-Sync: {state}{queue}',
  'admin.syncCopying': 'kopiert {copied}{total}',
  'admin.syncIdle': 'inaktiv',
  'admin.syncQueued': ' · in Warteschlange: {n}',
  'admin.testAi': '🤖 KI-Test',
  'admin.inQueue': '⏳ In Warteschlange{pos}',
  'admin.syncChangesTitle': 'Neue Änderungen seit dem letzten Sync. Klick lädt sie auf OneDrive.',
  'admin.syncChanges': '🔄 Änderungen synchronisieren',
  'admin.openOneDrive': '🔗 In OneDrive öffnen',
  'admin.oneDrive': '📤 OneDrive',
  'admin.resetTitle': 'KI-Bewertungen + Dateinamen zurücksetzen (Fotos bleiben, Kacheln werden wieder grün)',
  'admin.resetting': '🔄 Wird zurückgesetzt…',
  'admin.resetBtn': '🔄 KI-Status zurücksetzen',
  'admin.resetConfirm': 'KI für die Adresse "{address}" zurücksetzen?\n\n• Fotos bleiben (NICHTS wird gelöscht)\n• Bewertung (ok/Fail/Err) → gelöscht\n• OXG-Code (QR der Dose) → gelöscht\n• Dateinamen: Suffix _ok/_Fail/_Err verschwindet, TA_QR-Code wird wieder TA_zu_QR\n• Kacheln werden wieder grün, der KI-Test kann erneut laufen\n• Dateien auf OneDrive werden aktualisiert (alte Namen gelöscht, neue hochgeladen)\n\nFortfahren?',
  'admin.resetOk': '🔄 Reset OK: {photos} Fotos, {renamed} umbenannt, {archived} archiviert (_v(N)) · {s}s',
  'admin.retry': '↻ Erneut versuchen',
  'admin.weeksLoadFailed': 'Wochenliste konnte nicht geladen werden',
  'admin.teamsLoadFailed': 'Teamliste konnte nicht geladen werden',
  'admin.addressesLoadFailed': 'Fehler beim Laden der Adressen',
  'admin.lastKw': ' · zuletzt: KW{kw}',
  'admin.noTerminsSince': ' · keine Termine seit 12 Wochen',
  'admin.unassigned': 'nicht zugeordnet',

  // ─── AddressDetailScreen.jsx ───
  'addr.loadFailed': 'Daten konnten nicht geladen werden',
  'addr.fallbackName': 'Adresse',
  'addr.kndBadge': '{n}× KND',
  'addr.slotsCount': '· {n} Slots',
  'addr.deviationsTitle': 'Abweichungen: {list}',
  'addr.mischbauTitle': 'Gemischte Adresse (Typ-5)',
  'addr.keller': 'Keller',
  'addr.kellerSub': '(Untergeschoss)',
  'addr.bsSub': '(BS gesamt, Typ-5)',
  'addr.egSub': '(Erdgeschoss)',
  'addr.ogSub': '(Etage)',
  'addr.info': 'Info',
  'addr.noFloors': 'Keine Etagen in der Konfiguration.',
  'addr.config': '⚙️ Konfiguration',
  'addr.openOneDrive': 'Ordner in OneDrive öffnen',

  // ─── FloorWEListScreen.jsx ───
  'floor.bsKdSub': 'Hauptdurchbruch (ohne Keller)',
  'group.gebaeudeSub': 'Hausansicht + Klingel', // T Martina 02.10 (DN7): „Gebäudeansicht + Klingel" nie mieściło się w kafelku 2-kol. (121 > 105 px), wariant zapasowy z T; PL: „Budynek z daleka + Domofon"
  'group.aplSub': 'Abschlusspunkt (ohne Keller)', // krócej niż PL: pełna nazwa łamała się na 2 linie w kafelku APL
  'group.gvSub': 'Verteiler (ohne Keller)',
  'group.spEgSub': 'Sammelpunkt (ohne Keller)',
  'group.weSub': 'Wohnung',
  'group.lswegSub': 'Leitungsweg im Treppenhaus', // v79: Kachel LsWeg auf der Etage
  'group.lswegSubKg': 'Leitungsweg im Keller', // v79: Kachel LsWeg im Keller
  'group.bsSub': 'Brandschutz',
  'group.spSub': 'Sammelpunkt',
  'floor.noConfig': 'Keine Konfiguration, zuerst den Assistenten durchlaufen.',
  'floor.slotsLoadFailed': 'Fehler beim Laden der Slots',
  'floor.resetConfirm': 'KI für Etage {floor} zurücksetzen?\n\n• Fotos dieser Etage bleiben (werden NICHT gelöscht)\n• Bewertung (ok/Fail/Err) → gelöscht\n• Dateinamen: Suffix _ok/_Fail/_Err verschwindet, TA_QR-Code wird wieder TA_zu_QR\n• Slots der Etage werden wieder grün, KI-Prüfung kann erneut laufen\n• ⏱ Der Vorgang kann einige Minuten dauern\n\nFortfahren?',
  'floor.resetTimeout': 'Timeout nach 15 min, der Vorgang läuft eventuell im Backend weiter. Ansicht aktualisieren.',
  'floor.title': 'Etage',
  'floor.noSlots': 'Keine Slots auf {floor}.',
  'floor.kndHist': 'KND-Historie · {n} Fotos',
  'floor.kndHistProof': 'Besuchsnachweis (Archiv)',
  'floor.checkAi': '🤖 KI prüfen ({floor})',
  'floor.resetTitle': 'KI-Status der Etage zurücksetzen (Fotos bleiben, Bewertungen werden gelöscht)',
  'floor.resetting': '🔄 Etage wird zurückgesetzt…',
  'floor.resetBtn': '🔄 KI-Reset Etage ({floor})',
  'floor.resetLong': '⏱ Reset dauert bis zu 10 min, Fenster nicht schließen.',
  'floor.resetOk': '🔄 Reset OK: {photos} Fotos, {renamed} umbenannt · {s}s',

  // ─── małe komponenty UI (WeCountersBar, AppErrorBoundary, GalleryModeToggle, LongPressTrash, ThemeToggleButton) ───
  'weCounters.wePlanned': 'TA gesamt',
  'weCounters.wePlannedTitle': 'An dieser Adresse geplante WE',
  'weCounters.taMounted': 'montiert',
  'weCounters.taMountedTitle': 'TA montiert: WE mit vollständigen Slots',
  'weCounters.vorbereitung': 'Vorb.',
  'weCounters.vorbereitungTitle': 'Vorbereitung: WE vom Typ KND mit vollständigen Slots',
  'weCounters.wInProgress': 'in Arbeit',
  'weCounters.wInProgressTitle': 'In Arbeit: begonnen, noch unvollständig',
  'errb.unknown': 'unbekannter Fehler',
  'errb.title': 'Die App ist auf einen Fehler gestoßen',
  'errb.body': 'Die Fotos in der Warteschlange sind sicher im Handyspeicher. App neu laden; wenn der Fehler zurückkommt, Diagnose senden.',
  'errb.reload': 'Neu laden',
  'errb.sent': '✓ Diagnose ist in der Zentrale angekommen',
  'errb.queued': '✓ Diagnose gespeichert (wird bei Empfang gesendet)',
  'errb.send': 'Diagnose an die Zentrale senden',
  'galleryMode.ariaGallery': 'Modus: Galerie (auf Kamera umschalten)',
  'galleryMode.ariaCamera': 'Modus: Kamera (auf Galerie umschalten)',
  'galleryMode.titleGallery': 'Galeriemodus, Klick wechselt zur Kamera',
  'galleryMode.titleCamera': 'Kameramodus, Klick nutzt die Galerie des Handys',
  'trash.confirm': 'Wirklich löschen?',
  'trash.title': '3 s halten zum Löschen',
  'trash.aria': 'Löschen (3 s halten)',

  // --- KellerViewScreen.jsx + SPSlotsScreen.jsx ---
  'keller.title': 'Keller',
  'keller.aplSub': 'Abschlusspunkt',
  'keller.aplnSub': 'Abschlusspunkt Linie',
  'keller.gvSub': 'Verteiler',
  'keller.noSlots': 'Keine Slots im Keller für diesen Installationstyp.',
  'keller.checkAi': '🤖 KI prüfen (Keller)',
  'slots.photosHeader': 'Fotos · {sub}',
  'sp.idLabel': 'SP-Kennzeichnung',
  'sp.spleissLabel': 'Spleiß (min. {min}, max. 6)',
  'sp.photosHere': 'Fotos in diesem SP: {n}',
  'photo.deleteFailed': 'Foto konnte nicht gelöscht werden',
  'photo.addFailed': 'Foto konnte nicht hinzugefügt werden',

  // --- GVSlotsScreen.jsx ---
  'gv.idName': 'Kennzeichnung (Aufkleber)',
  'gv.offen': 'GV geöffnet (Innenansicht)',
  'gv.spleiss': 'Spleißkassette (min. {min})',
  'apl.offen': 'APL geöffnet (Innenansicht)',
  'apl.id': 'APL, Kennzeichnung',
  'bs.minLabel': 'Brandschutz (min. {min})',
  'spg.id': 'SP, Kennzeichnung',
  'spg.spleiss': 'Spleiße (min. {min})',
  'slot.generic': 'Foto',
  'gv.title': 'Verteiler {sub}',
  'apl.title': 'Punkt {sub}',
  'bs.minusConfirm': 'BS{n}-KD hat {photos} Fotos. Diesen Durchbruch samt Fotos löschen? (Admin-Zwang, nicht rückgängig)',
  'bs.minusAdminOnly': 'BS- · nur Admin ({photos} Fotos)',
  'bs.minusRemove': 'BS- · BS{n}-KD löschen',
  'bs.plus': 'BS+ · weiteren Durchbruch aus dem Keller hinzufügen',
  'lock.title': 'Sperre',
  'gv.photosHere': 'Fotos in {sub}: {n}',

  // --- FloorSubfolderScreen.jsx ---
  'sub.bsLabel': 'Brandschutz (Abdichtung)',
  'sub.gebaeudeFern': 'Gebäude (Gesamtansicht)',
  'sub.domofon': 'Klingelanlage',
  'sub.lswegTitle': 'Leitungsweg (LsWeg)', // Schaltfläche „KI prüfen (…)” auf der LsWeg-Ansicht der Etage (unverändert)
  'sub.lswegTitleFloor': 'Leitungsweg im Treppenhaus (LsWeg)', // v79: Titel der Unteransicht
  'sub.lswegTitleKg': 'Leitungsweg im Keller (LsWeg)', // v79: Titel der Keller-Unteransicht
  'sub.unknown': 'Unbekannter Unterordner: {sub}',

  // --- PhotoTaskListScreen.jsx (ekran slotów WE) ---
  'we.photosLoadFailed': 'Fotos konnten nicht geladen werden',
  'we.cfgMissingWizard': 'Keine Gebäudekonfiguration. Zuerst den Konfigurationsassistenten durchlaufen.',
  'we.cfgMissing': 'Keine Konfigurationsdaten für diese Adresse.',
  'we.syncInProgress': 'Versand läuft ({done} von {total}), bitte warten',
  'we.noConnectionAuto': 'Keine Verbindung. Der Versand startet automatisch, sobald Empfang da ist.',
  'we.retrying': 'Versand wird wiederholt ({n} Fotos)…',
  'we.resetConfirm': 'KI für {floor}/{we} zurücksetzen?\n\n• Fotos dieser WE bleiben (werden NICHT gelöscht)\n• Bewertung (ok/Fail/Err) → gelöscht\n• Dateinamen: Suffix _ok/_Fail/_Err verschwindet\n• Slots der WE werden wieder grün, KI-Prüfung kann erneut laufen\n• ⏱ Der Vorgang kann einige Minuten dauern\n\nFortfahren?',
  'we.kndConfirm': '{we} als "Kunde nicht da" markieren?\n\n• 3 Fotos genügen: Namensschild, QR-Aufkleber, Rotlicht-Test\n• Die übrigen WE-Slots werden AUSGEBLENDET\n• Rückgängig möglich (KND-Schalter), wenn der Kunde erscheint\n\nFortfahren?',
  'we.kndEnableFailed': 'KND konnte nicht eingeschaltet werden',
  'we.reloConfirmOn': 'TA an anderer Stelle als vorgesehen montiert (auf Kundenwunsch, mit Zustimmung des Eigentümers)?\n\n• der Slot „Gesamtansicht” wechselt in den erweiterten Modus\n• ein Button für die Einverständniserklärung zur Unterschrift erscheint',
  'we.reloConfirmOffSigned': 'Modus „TA versetzt” ausschalten?\n\nDer Dokument-Slot wird ausgeblendet, das unterschriebene Dokument BLEIBT aber in der Dokumentation (das Büro sieht es weiterhin).',
  'we.reloConfirmOff': 'Modus „TA versetzt” ausschalten?',
  'we.docSavedToast': '📄 Einverständniserklärung gespeichert, PDF in der WE-Ablage, Kopie geht in die AKP\'s-Mappe',
  'we.kndDisableFailed': 'KND konnte nicht ausgeschaltet werden',
  'we.slotNotCreated': 'Slot noch nicht angelegt. Zuerst ein Foto hochladen, dann zurücknehmen.',
  'we.deactivateConfirm': 'Kein Leitungsweg in dieser Wohnung?\n\nDer Slot "{label}" wird deaktiviert und zählt nicht zum Fortschritt. Die Anzahl erforderlicher Slots sinkt von {from} auf {to}.\n\nRückgängig über „↩ Aktivieren”.',
  'we.deactivateFailed': 'Slot konnte nicht deaktiviert werden',
  'we.reactivateFailed': 'Slot konnte nicht aktiviert werden',
  'we.doneCount': '{done}/{total} erledigt',
  'we.kndActive': '🚪 KND aktiv',
  'we.since': 'seit {date}',
  'we.kndArchiveInfo': '🚪 KND-Archiv, Besuchsnachweis (nur Ansicht). Die Fotos zählen zur Dokumentation und zu OneDrive; den neuen Anschluss machst du in der normalen WE-Kachel.',
  'we.residentAbsent': 'Bewohner abwesend',
  'we.residentPresent': 'Bewohner anwesend',
  'we.kndAriaAbsent': 'Bewohner abwesend, umschalten, wenn der Kunde da ist',
  'we.kndAriaPresent': 'Bewohner anwesend, auf Kunde nicht da umschalten',
  'we.kndTitleAbsent': 'Kunde erschienen? Umschalten, um KND auszuschalten (Grund erforderlich)',
  'we.kndTitlePresent': 'Kunde nicht da? Auf KND umschalten, 3 Nachweisfotos genügen',
  'we.docAdminNote': '📄 Einverständniserklärung (unterschrieben: {kunde}), Modus vom Techniker ausgeschaltet, Dokument bleibt',
  'we.noLocalData': 'Keine lokalen Daten für diese Adresse.',
  'we.tryAgain': '↻ Erneut versuchen',
  'we.slotDeactivated': 'Slot deaktiviert, zählt nicht zum Fortschritt',
  'we.activate': '↩ Aktivieren',
  'we.noRouteTitle': 'Kein Leitungsweg in dieser Wohnung, der Slot wird deaktiviert (zählt nicht zum Fortschritt)',
  'we.deactivating': '🔄 Wird deaktiviert…',
  'we.noRouteHere': '❌ Hier kein Leitungsweg',
  'we.uploadTitle': 'Fotoversand',
  'we.sendingLong': 'Sende {done} von {total} Fotos, bitte warten. In der Warteschlange dieser Wohnung: {n} ({slots}).',
  'we.notSentLong': 'Nicht gesendet: {n} Fotos ({slots}). Tipp auf „Erneut versuchen” startet den Versand sofort; ohne Empfang startet er von selbst, sobald er zurück ist.',
  'we.sendingShort': '⏳ Sende… ({done} von {total})',
  'we.notSentShort': '⚠ Nicht gesendet: {n} Fotos ({slots})',
  'we.sending': 'Sende…',
  'we.aiRunning': '🤖 Komplett! KI prüft automatisch…',
  'we.aiDone': '🤖 KI: geprüft ✓ (automatischer Start)',
  'we.aiIdle': '🤖 KI startet von selbst, sobald alles komplett ist',
  'we.inPwa': 'In PWA: {n} Fotos',
  'we.kndDisableTitle': '↩ KND für {we} ausschalten?',
  'we.kndDisableIntro': 'Kunde erschienen → Nachmontage. Nach dem Ausschalten:',
  'we.kndLi1Pre': 'WE kehrt zurück zu ',
  'we.kndLi1Strong': '6 Standard-Slots',
  'we.kndLi2Pre': 'Slot ',
  'we.kndLi2Post': ' deaktiviert (vorhandene Fotos → historisch)',
  'we.kndLi3Pre': 'Slots ta_name (Name) und ta_zu_qr (QR): freigegebene Fotos ',
  'we.kndLi3Strong': 'bleiben',
  'we.reasonLabel': 'Grund für das Ausschalten (Audit) ',
  'we.reasonPlaceholder': 'z. B. Kunde zurück, Nachmontage, Irrtum',
  'we.reasonHint': 'ⓘ Grund eingeben (min. 3 Zeichen)',
  'we.reasonCount': ', bisher {n}/3',
  'we.reasonTitle': 'Grund eingeben (min. 3 Zeichen)',
  'we.disableKndTitle': 'KND ausschalten',
  'we.disabling': '🔄 Wird ausgeschaltet…',
  'we.disableKnd': '↩ KND ausschalten',
  'we.resetTitle': 'KI-Status für {we} zurücksetzen (Fotos bleiben, Bewertungen werden gelöscht)',
  'we.resetting': '🔄 WE wird zurückgesetzt…',
  'we.resetBtn': '🔄 KI-Reset ({we})',

  // --- SlotButton.jsx ---
  'slotBtn.queuedName': 'wartet auf Versand',
  'slotBtn.emptyCamera': 'Leeres Foto von der Kamera, bitte noch einmal aufnehmen',
  'slotBtn.saveLocalFailed': 'Foto konnte nicht auf dem Handy gespeichert werden',
  'slotBtn.noFolders': 'Einzelne Dateien ablegen, keine Ordner',
  'slotBtn.notImages': 'Die abgelegten Elemente sind keine Bilder (image/*)',
  'slotBtn.qUploading': 'Wird gesendet…',
  'slotBtn.qFailed': 'Nicht gesendet (5 Versuche), „Jetzt senden” nutzen',
  'slotBtn.qWaiting': 'Wartet auf Versand',
  'slotBtn.thumbQueuedAria': 'Foto {n}: wartet auf Versand',
  'slotBtn.thumbAria': 'Foto {n} ansehen',
  'slotBtn.openDocAria': 'Einverständniserklärung öffnen',
  'slotBtn.docTitle': 'Einverständniserklärung (TA versetzt)',
  'slotBtn.moreAria': '{n} Fotos insgesamt, die übrigen in der Galerie',
  'slotBtn.musterAria': 'Musterfoto ansehen',
  'slotBtn.musterTitle': 'So soll dieses Foto aussehen',
  'slotBtn.musterCaption': 'Muster',
  'slotBtn.aiVerified': 'KI-geprüft',
  'slotBtn.aiProblem': 'KI hat ein Problem gefunden',
  'slotBtn.aiError': 'Fehler bei der KI-Prüfung',
  'slotBtn.showReason': 'Ablehnungsgrund anzeigen',
  'slotBtn.rejectedBgAria': 'Foto im Hintergrund abgelehnt, Grund anzeigen',
  'slotBtn.rejectionLine': '⛔ {reason}{file}. Neues Foto aufnehmen.',
  'slotBtn.reloOn': 'TA mit Zustimmung versetzt{check}',
  'slotBtn.reloAsk': 'TA an anderer Stelle?',
  'slotBtn.galleryAria': 'Aus der Galerie des Handys wählen',
  'slotBtn.cameraAria': 'Foto aufnehmen (1 s halten für die Galerie)',
  'slotBtn.galleryTitle': 'Galeriemodus: fertiges Foto vom Handy wählen.',
  'slotBtn.cameraTitle': 'Klick = Kamera. 1 s halten = Galerie des Handys.',
  'slotBtn.docBtn': '📄 Einverständniserklärung, Unterschrift des Kunden{check}',
  'slotBtn.docNote': 'TA mit Zustimmung des Eigentümers versetzt · Dokument kommt in die Dokumentation',

  // --- PhotoGallery.jsx (lightbox) ---
  'gal.err.gemini_timeout': 'Gemini hat das Zeitlimit überschritten',
  'gal.err.gemini_rate_limit': 'Gemini Rate-Limit (429), gleich erneut versuchen',
  'gal.err.gemini_5xx': 'Gemini Serverfehler (5xx)',
  'gal.err.gemini_parse_error': 'Gemini hat ungültiges JSON geliefert',
  'gal.err.gemini_not_configured': 'Gemini API-Key nicht konfiguriert',
  'gal.err.gemini_unknown': 'Unbekannter Gemini-Fehler',
  'gal.err.network': 'Netzwerkfehler / keine Verbindung zur API',
  'gal.err.photo_without_slot': 'Foto ohne Slot, die KI hat nichts zu bewerten. Bei Martin melden.',
  'gal.err.recheck': 'Fehler bei der erneuten Prüfung',
  'gal.cancelSelect': 'Auswahl abbrechen',
  'gal.deselect': 'Dieses Foto abwählen',
  'gal.selectForDelete': 'Dieses Foto zum Löschen markieren',
  'gal.queuedNoTrash': 'Foto wartet auf Versand, Papierkorb nach der Synchronisierung',
  'gal.spaceHint': 'Leertaste = aktuelles Foto markieren/abwählen',
  'gal.thisPhoto': 'Dieses Foto',
  'gal.deleting': 'Wird gelöscht…',
  'gal.deleteN': 'Löschen ({n})',
  'gal.emptySkipped': 'Leere Datei übersprungen: {name}',
  'gal.addFromGalleryAria': 'Aus der Galerie des Handys hinzufügen',
  'gal.addFromGalleryTitle': 'Foto aus der Galerie des Handys hinzufügen',
  'gal.trashAria': 'Fotos löschen (Auswahl)',
  'gal.trashTitle': 'Klicken, um Fotos zum Löschen auszuwählen',
  'gal.photoAlt': 'Foto',
  'gal.prev': 'Vorheriges Foto',
  'gal.next': 'Nächstes Foto',
  'gal.queuedStrong': 'Wartet auf Versand',
  'gal.queuedUploading': ' (wird gesendet…)',
  'gal.queuedFailed': ' (fehlgeschlagen, „Jetzt senden” nutzen)',
  'gal.queuedRest': '. Das Foto ist auf dem Handy; KI-Bewertung und Papierkorb nach der Synchronisierung.',
  'gal.closeError': 'Fehlermeldung schließen',
  'gal.rejectedByOffice': 'Manuell vom Büro abgelehnt',
  'gal.office': 'Büro:',
  'gal.aiErrorAria': 'KI-Fehler',
  'gal.aiErr': 'Prüfung fehlgeschlagen{reason}. „Erneut prüfen” versuchen.',
  'gal.acptAria': 'Manuell akzeptiert',
  'gal.acptStrong': 'Manuelle Freigabe',
  'gal.acptRest': ', ursprünglich Fail/Err von der KI',
  'gal.rejectTitle': 'Freigabe zurücknehmen, das Foto wird wieder rot zur Korrektur',
  'gal.reject': '⛔ Ablehnen',
  'gal.acceptManual': '✅ Manuell akzeptieren',
  'gal.noDetails': 'Keine Fehlerdetails',
  'gal.orphanMsg': 'Das Foto ist keinem Slot zugeordnet',
  'gal.noConnection': 'Keine Verbindung',
  'gal.recheckTitle': 'Dieses Foto erneut an Gemini senden (z. B. nach err timeout)',
  'gal.rechecking': '🔄 Wird geprüft…',
  'gal.recheck': '🔄 Erneut prüfen',
  'gal.acceptAllConfirm': '{n} von {total} Fotos im Slot akzeptieren?\n\nAlle nicht akzeptierten Fotos bekommen verdict=\'acpt\' (manuelle Freigabe) + Suffix _Acpt im Dateinamen. Der OneDrive-Sync bekommt den aktualisierten Dateinamen.',
  'gal.bulkError': 'Fehler beim Bulk-Override',
  // Paket v81 (MONIT 2026-10-04_0101 Aufg. 2): Singular/Plural (1 Foto / n Fotos).
  'gal.acceptAllTitle': { one: '1 Foto in diesem Slot akzeptieren (Admin Bulk-Override)', other: 'Alle {n} Fotos in diesem Slot auf einmal akzeptieren (Admin Bulk-Override)' },
  'gal.acceptingAll': '✓ Akzeptiere alle…',
  'gal.acceptAll': { one: '✓ Ganzen Slot akzeptieren (1 Foto)', other: '✓ Ganzen Slot akzeptieren ({n} Fotos)' },
  'gal.overrideTitle': '✅ Foto manuell akzeptieren',
  'gal.aiRejected': 'Die KI hat dieses Foto abgelehnt:',
  'gal.reasonSheetTitle': 'Ablehnungsgrund der KI',
  'gal.noReason': 'kein Grund',
  'gal.ovPre': 'Nach Klick auf ',
  'gal.ovAccept': 'Akzeptieren',
  'gal.ovMid': ': die Bewertung wechselt auf ',
  'gal.ovMid2': ', die Datei wird umbenannt ',
  'gal.ovPost': ', wir speichern ein Audit (wer, wann, warum).',
  'gal.reasonOptional': 'Grund (optional, max. 500 Zeichen):',
  'gal.reasonPlaceholder': 'z. B. Gemini zu streng, Foto in Ordnung',
  'gal.overrideError': 'Fehler beim Override',
  'gal.accepting': 'Wird akzeptiert…',
  'gal.accept': '✅ Akzeptieren',
  'gal.rejectModalTitle': '⛔ Akzeptiertes Foto ablehnen',
  'gal.rjReject': 'Ablehnen',
  'gal.rjMid': ': die Bewertung wird wieder rot (',
  'gal.rjPost': ' im Dateinamen), Slot und Adresse werden rot, der Techniker sieht den Grund und muss nachfotografieren. Wir speichern ein Audit (wer, wann, Grund). Das Foto wird NICHT gelöscht.',
  'gal.reasonForTech': 'Grund für den Techniker (optional, max. 500 Zeichen):',
  'gal.rejectPlaceholder': 'leer = „manuell vom Büro abgelehnt”',
  'gal.rejectError': 'Fehler beim Ablehnen',
  'gal.rejecting': 'Wird abgelehnt…',

  // --- UploadErrorToast + ForceUploadButton + AiCheckButton ---
  'upToast.serverErr': 'Serverfehler (HTTP {status})',
  'upToast.connErr': 'Verbindungsfehler',
  'upToast.httpErr': 'HTTP-Fehler {status}',
  'upToast.notSent': '⚠ Foto wurde nicht gesendet: {label}',
  'upToast.retry': '🔄 Erneut versuchen',
  'force.idle': '📤 Jetzt senden',
  'force.pressing': '⏳ Wird gesendet…',
  'force.done': '✓ Gesendet',
  'force.partial': '⚠ nicht gesendet ({n})',
  'force.title': 'Versand der Warteschlange erzwingen (wenn Android Chrome den automatischen Sync verzögert)',
  'ai.afterSyncToast': 'Die KI-Prüfung startet nach der Synchronisierung: {n} Fotos warten auf Versand.',
  'ai.unknownError': 'Unbekannter Fehler bei der KI-Prüfung',
  'ai.running': '🤖 KI prüft Fotos… (bis 60 s)',
  'ai.afterSync': '{label}, nach der Synchronisierung ({n} warten)',
  'ai.check': '🤖 KI prüfen',
  'ai.errorTitle': '⚠ Fehler bei der KI-Prüfung',
  'ai.resultTitle': '🤖 KI-Ergebnis',
  'ai.checkedPre': 'Geprüft: ',
  'ai.checkedPost': ' Slots',
  'ai.skippedN': ' (+ {n} übersprungen)',
  'ai.pillSkipped': 'ÜBERSPR.',
  'ai.skippedNote': 'ℹ️ {n} {slotWord} übersprungen, die Fotos hatten schon eine KI-Bewertung (ok/fail/err). Um ein Foto erneut zu bewerten, öffne es und nutze „Erneut prüfen”.',
  'ai.slotWord': { one: 'Slot', other: 'Slots' },
  'ai.errorDetails': 'Fehlerdetails ({n})',
  'ai.sheetTitle': 'KI-Prüfung',
  'ai.noKey': 'Der Gemini-API-Key ist auf dem Server noch nicht gesetzt. Administrator kontaktieren.',
  'ai.failHintPre': 'Slots mit Bewertung ',
  'ai.failHintPost': ' haben jetzt Fehlerstatus: in der Etagenansicht finden (rote Rahmen) und neue Fotos machen. Nach dem neuen Foto die KI erneut starten.',

  // --- BulkAcceptButton + WeTypeButton ---
  'bulk.scope.slot': 'Slot',
  'bulk.scope.group': 'Gruppe',
  'bulk.scope.floor': 'Etage',
  'bulk.scope.address': 'ganze Adresse',
  'bulk.unknownError': 'Unbekannter Fehler beim Bulk-Override',
  'bulk.btn': '✅ Alle akzeptieren ({scope}){count}',
  'bulk.errTitle': '⚠ Fehler beim Bulk-Override',
  'bulk.savedTitle': '✅ Bulk-Override gespeichert',
  'bulk.title': 'Alle akzeptieren ({scope})',
  'bulk.exPre': 'Die Aktion setzt alle Fotos mit Bewertung ',
  'bulk.exMid': ' auf ',
  'bulk.exPost': ' im Bereich {scope}. Die Dateien werden umbenannt (_Fail.jpg → _ok.jpg) und der Slot-Status wird aktualisiert.',
  'bulk.reasonLabel': 'Grund (optional, standardmäßig Zeitstempel + Admin-Login)',
  'bulk.reasonPlaceholder': 'z. B. Falschmeldung Gemini, Zement+Kabel korrekt verspachtelt',
  'bulk.syncCheckbox': '📤 Nach dem Akzeptieren OneDrive-Sync starten (rclone copy + Share-Link)',
  'bulk.accepting': 'Wird akzeptiert…',
  'bulk.confirm': '✅ Bestätigen',
  'bulk.acceptedPre': 'Akzeptiert: ',
  'bulk.acceptedPost': ' Fotos',
  'bulk.skipped': ' (+ {n} übersprungen, schon ok)',
  'bulk.nothingUnverdicted': 'Nichts zu akzeptieren: {n} Fotos ohne Bewertung, zuerst „KI prüfen” starten.',
  'bulk.nothing': 'Nichts zu akzeptieren in diesem Bereich (keine Fotos fail/err und keine ohne Bewertung).',
  'bulk.breakdown': 'Aufschlüsselung pro slot_kind',
  'bulk.syncStarted': '📤 OneDrive-Sync gestartet, der Share-Link erscheint im Admin-Panel, sobald rclone fertig ist.',
  'bulk.renameWarn': '⚠ Ein Teil der Dateien wurde nicht umbenannt (ENOENT oder Berechtigung). Bewertung in der DB gespeichert.',
  'bulk.recalcWarn': '⚠ Neuberechnung des Slot-Status teilweise fehlgeschlagen, Ansicht manuell aktualisieren.',
  'bulk.closeRefresh': 'Schließen und aktualisieren',
  'wt.typeHeader': 'Wohnungstyp',
  'wt.deviationSuffix': '· Abweichung vom Adresstyp',
  'wt.fedFrom': 'versorgt aus {ref}',
  'wt.changeHeader': 'Wohnungstyp ändern',
  'wt.current': 'aktuell',
  'wt.back': 'Zurück',
  'wt.fedQuestion': 'Versorgt aus: welche Wohnung eine Etage tiefer?',
  'wt.next': 'Weiter',
  'wt.confirmHeader': 'Bestätigung',
  'wt.saving': 'Speichern und Slots neu aufbauen…',
  'wt.aria': 'Wohnungstyp: {label}. Tipp öffnet Beschreibung und Typwechsel.',
  'wt.badgeV1': '🔒 v1',
  'wt.badgeDeviation': 'Abweichung',
  'wt.badgeDesc': 'Info ›',
  'wt.default': ' (Standard)',

  // --- OfflineBanner + VersionBanner ---
  'ob.localOn': 'Lokaler Modus eingeschaltet: Fotos bleiben auf dem Handy, Versand pausiert.',
  'ob.syncOn': 'Synchronisierung eingeschaltet.',
  'ob.photoLost': 'Foto NICHT gesendet ({where}): {reason}. Neues Foto aufnehmen.',
  'ob.lostStrip': '🗑 {n} vom System verlorene Fotos entfernt, Details im Service',
  'ob.memory': '⚠ Die Warteschlange belegt {mb} Handyspeicher. Fotos bei gutem Empfang senden.',
  'ob.reachQ': '📶 Empfang da. Synchronisierung einschalten?',
  'ob.enableSync': 'Synchronisierung einschalten',
  'ob.toggleAriaOn': 'Lokaler Modus eingeschaltet, Tipp = Synchronisierung einschalten',
  'ob.toggleAriaOff': 'Lokalen Modus einschalten (Fotos bleiben auf dem Handy)',
  'ob.toggleTitleOn': 'Lokaler Modus: Versand pausiert, Ansichten aus dem Handyspeicher',
  'ob.toggleTitleOff': 'Lokaler Modus: Sicherung, wenn der Hintergrund versagt (Keller, schlechter Empfang)',
  'ob.localMode': 'Lokaler Modus',
  'ob.localBanner': '🔒 Lokaler Modus: {n} {photos} auf dem Handy ({mb})',
  'ob.offline': '📵 Offline, Fotos lokal gespeichert ({n} in der Warteschlange)',
  'ob.weakN': '📶 Schwacher Empfang, zeige letzten Stand ({n} Fotos warten)',
  'ob.weak': '📶 Schwacher Empfang, zeige letzten Stand',
  'ob.failed': '⚠ {n} {photos} konnten nicht gesendet werden{waiting}',
  'ob.waiting': ' ({n} warten)',
  'ob.retry': '↻ Erneut versuchen',
  'ob.stall': '⚠ Warteschlange steht: {n} {photos}, {tail}',
  'ob.threshold': '⏳ {n} {photos} ({mb}) warten auf Versand',
  'vb.requiredTitle': 'Update erforderlich{t}',
  'vb.requiredBody': 'Die Dateien der neuen Version sind schon auf dem Handy. Ein Tipp genügt, geht auch ohne Internet. Fotos in der Warteschlange bleiben.',
  'vb.reloading': 'Wird neu geladen…',
  'vb.haveRequired': 'du hast {shell} · erforderlich {min}',
  'vb.dismissAria': 'Schließen (kommt in einer Stunde zurück)',

  // --- FleetSection + WeekPickerScreen + CustomDropdown ---
  'fleet.renamePrompt': 'Eigener Name für „{label}” (max. 30 Zeichen; leer = entfernen):',
  'fleet.title': 'Geräteflotte',
  'fleet.latestCounter': 'auf der neuesten ({latest}): {count}',
  'fleet.minRequired': '· erforderlich min. ',
  'fleet.allTeams': 'alle Teams',
  'fleet.noDevices': 'Keine Geräte (der erste Puls kommt nach dem Öffnen der App in der neuen Version).',
  'fleet.colLabel': 'Bezeichnung',
  'fleet.colVersion': 'Version · SW · Dateien',
  'fleet.colQueue': 'Warteschlange',
  'fleet.colLocal': 'Lokal',
  'fleet.colPulse': 'Puls',
  'fleet.colDiag': 'Diagnose',
  'fleet.legend': 'rot = unter der erforderlichen Version / Installation fehlgeschlagen / kein Puls > 4 Tage · gelb = lädt / älter · grün = neueste komplett',
  'fleet.renameTitle': 'Eigenen Namen ändern',
  'fleet.firstTeam': 'erstes Team: {team}',
  'fleet.yes': '🔒 ja',
  'fleet.no': 'nein',
  'fleet.noEntries': 'keine Einträge',
  'wp.current': 'Aktuell',
  'wp.nextWeeks': 'Kommende Wochen',
  'dd.placeholder': 'Wählen…',
  'dd.apply': 'Übernehmen',
  'dd.checkWeek': 'Woche markieren',

  // --- weekPicker.js ---
  'wp.older': 'Ältere Wochen',
  'wp.olderTo': 'Ältere Wochen (bis KW {kw}{y})',

  // --- InfoScreen + AdminQueueScreen + SupportLiteScreen ---
  'info.domofon': 'Klingelanlage (Namen lesbar)',
  'info.loadFailed': 'Fehler beim Laden der Info-Daten',
  'info.saveNoteFailed': 'Notiz konnte nicht gespeichert werden',
  'info.entranceTitle': 'Eingangsfotos, Pflicht',
  'info.entranceHint': 'Gebäude + Klingelanlage machst du am Eingang, bevor du den Montagetyp wählst. Ohne KI-Bewertung, der komplette Satz schaltet die Typwahl frei.',
  'info.complete': '✓ komplett',
  'info.akpTitle': 'AKP\'s, Dokumente',
  'info.noDocs': 'keine Dokumente',
  'info.openExtra': '📷 Extra Foto öffnen (Fotos ohne Beschreibung)',
  'info.notizTitle': 'Notiz, Techniker Bemerkung',
  'info.noNotes': 'keine Notizen',
  'info.addNoteLabel': 'Notiz hinzufügen (wird am Ende angehängt, bestehende Einträge bleiben)',
  'info.notePlaceholder': 'Deine Notiz…',
  'info.savingNote': 'Wird gespeichert…',
  'info.addNote': 'Notiz hinzufügen',
  'aq.copyFailed': 'Kopieren fehlgeschlagen: {err}',
  'aq.noAccess': 'Kein Zugriff.',
  'aq.diag': 'DIAGNOSE · READ-ONLY',
  'aq.title': 'Offline-Warteschlange',
  'aq.total': 'Gesamt',
  'aq.pending': 'Wartet',
  'aq.uploading': 'Sendet',
  'aq.failed': 'Fehlgeschlagen',
  'aq.refresh': '↻ Aktualisieren',
  'aq.copied': '✓ Kopiert',
  'aq.export': 'JSON exportieren',
  'aq.empty': 'Warteschlange leer, keine Fotos warten auf Versand.',
  'aq.colAddress': 'Adresse / KW',
  'aq.colFloor': 'Etage',
  'aq.colFile': 'Datei',
  'aq.colSize': 'Größe',
  'aq.colCreated': 'Erstellt',
  'aq.colLastTry': 'Letzter Versuch',
  'aq.colError': 'Fehler',
  'aq.colLastFailed': 'Letzter Fehlerstatus',
  'sl.named': 'Handy benannt: {name}',
  'sl.nameRemoved': 'Eigener Name entfernt',
  'sl.nameFailed': 'Name konnte nicht gespeichert werden: {err}',
  'sl.diagFailed': 'Diagnoseversand fehlgeschlagen: {err}',
  'sl.weak': 'schwacher Empfang',
  'sl.header': 'SERVICE · DIESES HANDY',
  'sl.title': 'FiberOps · Service',
  'sl.thisPhone': 'Dieses Handy in der Zentrale',
  'sl.noLabel': 'noch ohne Bezeichnung',
  'sl.labelHint': 'die Bezeichnung vergibt die Zentrale bei der ersten Verbindung',
  'sl.namePlaceholder': 'Dieses Handy benennen (z. B. Samsung Kamila)',
  'sl.app': 'App',
  'sl.swFiles': 'SW · Dateien',
  'sl.net': 'Netz',
  'sl.queue': 'Warteschlange',
  'sl.lastSent': 'Zuletzt gesendet',
  'sl.localOn': '🔒 EIN',
  'sl.localOff': '🔓 aus',
  'sl.localHint': 'Lokaler Modus: Fotos bleiben auf dem Handy, kein Netz (z. B. vor dem Gang in den Keller). Nach Rückkehr in den Empfang ausschalten.',
  'sl.reload': '🔄 Neu laden auf neue Version{t}',
  'sl.sending': 'Wird gesendet…',
  'sl.queued': '✓ Gespeichert, wird bei Empfang gesendet',
  'sl.diagError': '⚠ Fehlgeschlagen, bei Empfang erneut versuchen',
  'sl.callHint': 'Wenn du die Zentrale anrufst, nenne die Bezeichnung oben am Bildschirm.',

  // --- SupportScreen.jsx ---
  'ss.retryOffline': 'Gerät offline, bei Empfang erneut versuchen.',
  'ss.retryBusy': 'Die Warteschlange sendet gerade, kurz warten.',
  'ss.retryMissing': 'Eintrag existiert nicht (wurde eventuell gerade gesendet).',
  'ss.modeHeader': 'SERVICEMODUS · {mode}',
  'ss.modePlus': 'ERWEITERT',
  'ss.modeLimited': 'EINGESCHRÄNKT',
  'ss.netQueue': 'Netz und Warteschlange',
  'ss.namePlaceholder': 'Dieses Handy benennen',
  'ss.version': 'Version',
  'ss.queueVal': '{n} Fotos · {mb}',
  'ss.copyJson': 'JSON kopieren',
  'ss.colAddress': 'Adresse',
  'ss.colAction': 'Aktion',
  'ss.lostTitle': 'Verloren ({n}), Inhalt vom System zerstört',
  'ss.lostHint': 'Diese Fotos existieren nicht mehr im Handyspeicher (iOS kann den Inhalt der Offline-Warteschlange löschen). Sie müssen neu aufgenommen werden.',
  'ss.colTaken': 'Aufgenommen',
  'ss.colDetected': 'Erkannt',
  'ss.uploadLogTitle': 'Sendeversuche (letzte {n})',
  'ss.colWhen': 'Wann',
  'ss.colResult': 'Ergebnis',
  'ss.colSent': 'Gesendet',
  'ss.colOriginal': 'Original',
  'ss.colTime': 'Dauer',
  'ss.colAttempt': 'Versuch',
  'ss.footer': 'Read-only-Ansicht der Warteschlange DIESES Geräts. Die Warteschlange leert ein bestätigter Upload sowie der automatische Scan verlorener Einträge (sie landen im Register oben), keine MANUELLE Aktion löscht etwas.',

  // --- SystemSettingsSection.jsx ---
  'sys.windowAll': 'Alle',
  'sys.ttlEod': 'bis Tagesende',
  'sys.ttl24h': '24 Stunden',
  'sys.ttl7d': '7 Tage',
  'sys.kwBack': '{v} KW zurück',
  'sys.narrowConfirm': 'Du verengst das Upload-Fenster ({from} → {to}).\n\n⚠ VOR dem Verengen müssen die Warteschlangen der Techniker LEER sein, nicht gesendete Einträge\nfür alte KW bleiben als "failed" hängen (Lektion vom 29.08).\n\nFortfahren?',
  'sys.farbeOffConfirm': 'Du schaltest den Writeback der Adressfarbe (PWA_Farbe) nach Airtable aus.\n\nDas Büro sieht dann keine frische Farbe mehr; die Änderungen sammeln sich in der Datenbank und werden\nnach dem Wiedereinschalten nachgetragen (ohne Verlust).\n\nFortfahren?',
  'sys.minVerConfirm': 'Du setzt die erforderliche Mindestversion = {v}.\n\nHandys mit älterer Hülle, die schon den KOMPLETTEN Satz der neuen Version haben, bekommen ein bildschirmfüllendes\n„Neu laden” (ein Tipp, geht ohne Netz). Handys ohne vollständige Dateien arbeiten weiter\nmit dem Banner „bei Empfang abschließen”. Fotowarteschlangen unberührt.\n\nFortfahren?',
  'sys.title': 'Systemeinstellungen · voller Admin',
  'sys.deviationUpload': '⚠ Aktive Abweichung: Upload-Fenster = {v}, {until}{note}',
  'sys.deviationViewer': '⚠ Aktive Abweichung: kleiner Admin sieht {label}{detail}',
  'sys.weekWindows': 'Wochenfenster',
  'sys.weekWindowsHint': 'Techniker: wie viele Wochen zurück noch Fotos hochgeladen werden können (Standard {d1}). Kleiner Admin (Bernard, Damian): wie viel zurück und voraus im KW-Picker und in der Adressliste sichtbar ist (Standard {d2} / {d3}); den vollen Admin betrifft es nicht.',
  'sys.colRole': 'Rolle',
  'sys.colBack': 'zurück',
  'sys.colFwd': 'voraus',
  'sys.techs': 'Techniker',
  'sys.uploadWindow': 'Upload-Fenster',
  'sys.plusOne': '+1 (fest)',
  'sys.viewer': 'Kleiner Admin',
  'sys.browsing': 'Ansicht',
  'sys.otherNumber': 'andere Zahl…',
  'sys.intRange': 'ganze Zahl {min}–{max}',
  'sys.viewerNow': 'kleiner Admin jetzt: {label} · Picker {n} Einträge · ältester {oldest}',
  'sys.previewPre': 'Nach dem Speichern sieht der kleine Admin ',
  'sys.previewN': '{n} Einträge',
  'sys.previewPost': ' ({back} zurück + aktuelle + {fwd} voraus), älteste KW: {oldest}.',
  'sys.previewNarrow': ' Ältere Wochen verschwinden aus der Liste und lassen sich nicht mehr über gespeicherte Links öffnen.',
  'sys.notePlaceholder': 'Notiz für das Audit (wozu die Änderung?)',
  'sys.saving': 'Wird gespeichert…',
  'sys.saveN': 'Änderungen speichern ({n})',
  'sys.saved': '✓ Gespeichert. Gilt ab sofort (Cache bis 45 s).',
  'sys.farbeHint': 'Adressfarbe in Airtable (PWA_Farbe): Schreiben bei Farbwechsel + Abgleich 04:45.',
  'sys.farbeDeviation': '⚠ Farb-Writeback {label}{detail}',
  'sys.writeback': 'Writeback: {label}',
  'sys.off': 'Ausschalten',
  'sys.on': 'Einschalten',
  'sys.minHint': 'Erforderliche Mindestversion der PWA. Normaler Deploy = nur Banner „Neue Version bereit”; kritischer Deploy (z. B. Änderung des Warteschlangenformats) = Schwelle anheben. Sperre NUR bei vollständigen Dateien auf dem Handy.',
  'sys.minBlock': '⚠ Aktive Sperre: {label}{detail}',
  'sys.minLabel': 'min: {v}',
  'sys.latestLine': '· latest auf dem Server: {latest} · dieser Bildschirm: {app}',
  'sys.minPlaceholder': 'z. B. {v}',
  'sys.set': 'Setzen',
  'sys.clear': 'Leeren',
  'sys.history': 'Änderungsverlauf ({n})',

  // --- systemSettingsHelpers.js (minRequiredSummary) ---
  'settings.required': 'erforderlich {v}',
  'settings.noBlock': 'keine Sperre',

  // --- InstallTypeScreen.jsx ---
  'it.T1': 'Leerrohre',
  'it.T2': 'Schacht',
  'it.T3': 'Decke',
  'it.T4': 'Treppenhaus',
  'it.T5': 'Gemischt',
  'it.step': 'SCHRITT 1/3',
  'it.typeHeader': 'AUSBAUTYP',
  'it.title': 'Ausbautyp wählen',
  'it.infoSub': 'Pläne (AKP) · Notizen · Eingangsfotos',
  'it.mandatoryN': 'Pflicht {n}/2',
  'it.confirm': 'Auswahl bestätigen',

  // --- ErklaerungModal.jsx ---
  'erk.sigMissing': 'Unterschrift des Kunden fehlt, um Unterschrift im Rahmen bitten.',
  'erk.sigShort': 'Unterschrift zu kurz (nur ein Punkt?), um eine große Unterschrift bitten.',
  'erk.pdfFailed': 'PDF konnte nicht geladen werden ({err})',
  'erk.gruendeMissing': 'Mindestens einen Grund der abweichenden Montage ankreuzen.',
  'erk.andererMissing': 'Die Position „Anderer Grund” braucht eine kurze Beschreibung.',
  'erk.titleView': 'Einverständniserklärung, unterschrieben',
  'erk.titleForm': 'Einverständnis, geänderte TA-Montageposition',
  'erk.client': 'Kunde: ',
  'erk.pdfNeedsOnline': 'Die PDF-Vorschau braucht eine Internetverbindung.',
  'erk.openPdf': '📄 PDF öffnen',
  'erk.loadingPdf': '⏳ PDF wird geladen…',
  'erk.resign': '✍ Erneut unterschreiben (das neue Dokument ersetzt dieses)',
  'erk.keepNote': 'das unterschriebene Dokument bleibt in der Dokumentation, es lässt sich in der App nicht löschen',
  'erk.formHint': 'Adresse, Etage und WE ergänzt der Server, du füllst nur die Kundendaten aus.',
  'erk.positionLabel': 'Gewünschte Montageposition (optional)',
  'erk.positionPlaceholder': 'leer = „wie in der Fotodokumentation festgehalten”',
  'erk.loadingGruende': '⏳ Positionen werden vom Generator geladen…',
  'erk.tryAgain': 'Erneut versuchen',
  'erk.andererPlaceholder': 'Anderer Grund, kurze Beschreibung (1 Zeile)',
  'erk.generating': '⏳ Dokument wird erzeugt…',
  'erk.submit': '✍ Unterschrieben, PDF erzeugen und speichern',
  'erk.backToSigned': '← Zurück zum unterschriebenen Dokument',

  // --- BuildingConfigScreen.jsx ---
  'bc.decrease': 'Verringern',
  'bc.increase': 'Erhöhen',
  'bc.noWe': 'Keine WE',
  'bc.removeSp': 'SP entfernen',
  'bc.addSp': 'SP hinzufügen',
  'bc.parter': 'Erdgeschoss',
  'bc.floorN': 'Etage {n}',
  'bc.removeFloor': 'Etage entfernen',
  'bc.kellerSub': 'Keller (Untergeschoss)',
  'bc.kgExists': 'KG vorhanden',
  'bc.moreClicks': 'noch {n}',
  'bc.typeRowTitle': 'Ausbautyp der Adresse',
  'bc.oldRules': '🔒 alte Regeln (v1)',
  'bc.fetchFailed': 'Aktuelle Konfiguration konnte nicht geladen werden: {err}',
  'bc.removeFloorConfirm': 'Etage {floor} und {n} Slots löschen{photos}',
  'bc.withPhotos': ' mit {n} Fotos?',
  'bc.shrinkConfirm': 'Das Verringern der Anzahl WE/SP/GV/APL löscht {n} Fotos ({floors}). Fortfahren?',
  'bc.forceConfirm': '{msg}\n\nSpeichern erzwingen? Die Fotos dieser Slots werden unwiderruflich aus der App entfernt.',
  'bc.step': 'SCHRITT 2/3 · {type}',
  'bc.header': 'GEBÄUDEKONFIGURATION',
  'bc.title': 'Wie viele Wohnungen (WE) auf jeder Etage?',
  'bc.removeFloorBtn': '− Etage entfernen',
  'bc.addFloorBtn': '+ Etage hinzufügen',
  'bc.maxFloors': 'Maximal {n} Etagen',
  'bc.saveErrorTitle': 'Fehler beim Speichern',
  'bc.summary': 'Übersicht',
  'bc.total': 'Gesamt: ',
  'bc.clearing': 'Wird geleert…',
  'bc.clearAll': '🗑 Alles löschen',
  'bc.clearTitle': '⚠ ALLES für diese Adresse löschen?',
  'bc.clearPre': 'Es werden ',
  'bc.clearStrong': 'dauerhaft gelöscht',
  'bc.clearLi1': 'alle aufgenommenen Fotos dieser Adresse',
  'bc.clearLi2': 'die Gebäudekonfiguration (Montagetyp, Etagen, WE)',
  'bc.clearLi3': 'alle Foto-Slots',
  'bc.clearP': 'Die Adresse kehrt in den Zustand vor der Konfiguration zurück, es muss wieder mit der Wahl des Montagetyps begonnen werden. ',
  'bc.clearStrong2': 'Dieser Vorgang lässt sich nicht rückgängig machen.',
  'bc.reasonLabel': 'Grund für das Zurücksetzen (Audit Trail) ',
  'bc.reasonPlaceholder': 'z. B. Test-Cleanup, falsche WE-Anzahl',
  'bc.reasonHint': 'ⓘ Grund für das Zurücksetzen eingeben (min. 3 Zeichen)',
  'bc.resetDone': '✓ Zurücksetzen ausgeführt ({who})',
  'bc.admin': 'Admin',
  'bc.tech': 'Techniker',
  'bc.photosDeleted': ' · {n} Fotos gelöscht',
  'bc.slotsDeleted': ' · {n} Slots',
  'bc.backToType': 'Zurück zur Wahl des Montagetyps…',
  'bc.reasonTitle': 'Grund für das Zurücksetzen eingeben (min. 3 Zeichen)',
  'bc.clearAllTitle': 'Alles löschen',
  'bc.clearingShort': 'Wird gelöscht…',
  'bc.yesClear': 'Ja, löschen',

  // --- kody backendu (addytywne, MONIT 0526) ---
  'err.slot_min_photos': 'Der Slot hat die Mindestanzahl Fotos nicht erreicht.',
  'err.config_not_found': 'Die Adresse hat noch keine Gebäudekonfiguration. Zuerst den Assistenten speichern.',
  'err.invalid_pin': 'Ungültige PIN',
  'err.invalid_admin_pin': 'Ungültige Admin-PIN',
  'err.admin_disabled': 'Admin-Konto deaktiviert',

  // --- reszta (skan kontrolny) ---
  'dd.noOptions': 'Keine Optionen',
  'tile.progress': 'Fortschritt: ',
  'fleet.swInstalling': 'lädt',
  'fleet.swWaiting': 'wartet',
  'fleet.photosAbbr': 'Fotos',
  'api.offlineNoCache': 'Offline, keine Daten im Cache',

  // --- pakiet zad. 2+3 ---
  'bs.bs_we_w.t2': 'BS-WEw · Brandschott Wohnung → Kaminschacht',
  'bs.bs_we_w.t4_r': 'BS-WEw · Brandschott Wohnung → Revisionsöffnung',
  'bs.bs_we_w.t4_s': 'BS-WEw · Brandschott Wohnung → Treppenhaus',
  'bs.bs_we_w.f': 'BS-WEw · Brandschott Wohnung → Fassade',
  'err.airtable_unreachable': 'Adressliste konnte nicht geladen werden. Bitte gleich erneut versuchen.',
  'tasks.loadFailed': 'Adressliste konnte nicht geladen werden',
  'tasks.noAddressesNoTeam': 'Keine Adressen in dieser Woche.',

  // --- Lageplan (MONIT 2026-10-03_0903, B0) ---
  'plan.button': 'Lageplan',
  'plan.buttonSub': 'Hinterhaus, weiterer Eingang, weiterer Hof',
  'plan.title': 'Lageplan',
  'plan.leadHof1': 'Tippe die vorhandenen Gebäudeteile an. Links und rechts von der Straße aus gesehen. Darunter die Anzahl der Eingänge einstellen.',
  'plan.leadHofN': 'Hof {n} liegt hinter dem Hinterhaus von Hof {p}. Die Gebäudeteile an diesem Hof antippen.',
  'plan.addHof': '+ Hof hinzufügen',
  'plan.hofTopView': 'Hof {n} · Draufsicht',
  'plan.topView': 'Lageplan · Draufsicht',
  'plan.street': 'Straße · {street}',
  'plan.streetNoName': 'Straße', // Paket v81 Aufg. 4: ohne hängenden Punkt, wenn kein Name bekannt
  'plan.passage': 'Durchgang von Hof {n}',
  'plan.entrancesTitle': 'Anzahl Eingänge je Gebäudeteil',
  'plan.lessEntrances': 'Weniger Eingänge: {part}',
  'plan.moreEntrances': 'Mehr Eingänge: {part}',
  'plan.codeLine': 'Code dieses Gebäudeteils in Dateinamen: ',
  'plan.backNoSave': 'Zurück ohne Speichern',
  'plan.backToList': 'Zurück zur Adressliste',
  'plan.backToPlan': 'Zurück zum Lageplan',
  // MONIT 2026-10-03_1200 D2: „Eingänge" statt „Abschnitte"
  'plan.sectionsN': { one: '{n} Eingang', other: '{n} Eingänge' },
  'plan.hofsSections': '{h} Hof · {s}',
  'plan.configuredOf': { one: '{n} von {total} eingerichtet', other: '{n} von {total} eingerichtet' },
  'plan.configuredShort': '{n} von {total} eingerichtet',
  'plan.configure': 'Einrichten',
  'plan.infoShared': 'Info · gilt für die ganze Adresse',
  'plan.change': 'Plan ändern',
  'plan.here': 'Du bist hier',
  'plan.typeWe': '{type} · {n} WE',
  'plan.typeFloorsWe': { one: '{type} · {cellar}{n} Geschoss · {we} WE', other: '{type} · {cellar}{n} Geschosse · {we} WE' },
  'plan.cellarPlus': 'Keller + ',
  'plan.egSubEntry': 'Erdgeschoss · mit Gebäude und Klingelanlage',
  'plan.floorSub': 'Etage {n}',
  'conn.title': 'Verbindung (LsWeg)',
  'conn.sub': 'Leitungsweg zu diesem Gebäudeteil: Kanal, Rohr',
  'plan.aplMoveQ': 'APL von {from} hierher verschieben?',
  'plan.aplMoveBody': 'Pro Adresse gibt es genau einen APL. In {from} entfallen leere APL-Slots, Slots mit Fotos werden ausgeblendet, und der Gebäudeteil bekommt den Slot Verbindung (LsWeg).',
  'plan.aplMoveOk': 'APL verschieben',

  // --- plan posesji B2 (MONIT 2026-10-03_1740) ---
  'plan.saved': 'Lageplan gespeichert',
  'plan.saveFailed': 'Lageplan konnte nicht gespeichert werden',
  'plan.loadFailed': 'Lageplan konnte nicht geladen werden',
  'err.section_has_photos': 'Gebäudeteile mit Fotos entfernt nur der Admin: {list}',
  'err.plan_disabled': 'Der Lageplan ist ausgeschaltet. Der Admin schaltet ihn im Service ein.',
  'err.plan_hof_empty_middle': 'Ein Hof in der Mitte darf nicht leer sein. Zuerst den letzten Hof entfernen.',
  'err.plan_too_many_sections': 'Zu viele Eingänge im Plan (höchstens 100).',
  'err.plan_invalid': 'Der Plan hat einen ungültigen Aufbau.',
  'err.plan_hof_numbering': 'Höfe müssen fortlaufend nummeriert sein.',
  'err.section_unconfigured': 'Nicht alle Gebäudeteile sind eingerichtet. KI-Prüfung der ganzen Adresse erst danach.',
  'err.section_not_found': 'Diesen Gebäudeteil gibt es im Plan nicht mehr.',
  'err.apl_move_failed': 'APL konnte nicht verschoben werden. Bitte erneut versuchen.',
  // v79 Randfall (Meldung 1315, Variante a): Keller eines Gebäudeteils ohne APL
  'slot.leitungsweg.kg.noApl': 'Leitungsweg im Keller · Kabeleinführung → Deckendurchbruch',
  'sys.planTitle': 'Lageplan',
  'sys.planHint': 'Wer den Plan anlegt und ändert (Hinterhaus, Eingänge, Hof). Adressen mit Gebäudeteilen funktionieren immer.',
  'sys.planMode.off': 'Aus',
  'sys.planMode.admin': 'Nur Admin',
  'sys.planMode.all': 'Alle',
  // Paket v81 (MONIT 2026-10-04_0101 Aufg. 7-9): Wohnungssymbole, Schalter im Service, Text für Screenreader.
  'sys.weSymbolTitle': 'Wohnungssymbol',
  'sys.weSymbolHint': 'Wie Wohnungen auf den Kacheln angezeigt werden. Gilt für die ganze Firma: alle sehen, was der Admin einstellt.',
  'sys.weSymbol.house': 'Häuschen',
  'sys.weSymbol.door_building': 'Türen in der Gebäudeansicht',
  'sys.weSymbol.door_all': 'Türen überall',
  // Pakiet v81 zad. 14 (MONIT 2026-10-04_1213): Hintergrundlinien je Design (Designnamen: theme.lightTitle / theme.darkTitle).
  'sys.fiberBgTitle': 'Hintergrundlinien',
  'sys.fiberBgHint': 'Animierte Linien im Hintergrund der Bildschirme. Getrennt für helles und dunkles Design, gilt für die ganze Firma: alle sehen, was der Admin einstellt.',
  'sys.fiberOn': 'An',
  'sys.fiberOff': 'Aus',
  'weSym.count': { one: '1 Wohnung', other: '{n} Wohnungen' },
  'weSym.st.ai_verified': '{n} geprüft',
  'weSym.st.verified': '{n} vollständig',
  'weSym.st.kunde_nicht_da': '{n} KND',
  'weSym.st.in_progress': '{n} in Arbeit',
  'weSym.st.ai_error': '{n} KI-Fehler',
  'weSym.st.empty': '{n} leer',
  // MONIT 2026-10-04_1357 (FAZA A, plansze): Nummerierung über das ganze Grundstück, Spleißplan im APL, Slot „APL geöffnet".
  'plan.floorSubWe': 'Etage {n} · {we}',
  'splice.button': 'Spleißplan',
  'splice.title': 'Spleißplan',
  'splice.count': { one: '1 Spleiß', other: '{n} Spleiße' },
  'splice.cassettes': { one: '1 Kassette à 3', other: '{n} Kassetten à 3' },
  'splice.introPre': 'Aufkleber = Etage-Wohnung, z. B. ',
  'splice.introOrder': '. Reihenfolge: Etage für Etage, auf der Etage {order}. Kein Gebäudecode auf dem Aufkleber.',
  'splice.unconfigured': 'Nicht alle Gebäudeteile sind eingerichtet: der Plan kann sich noch ändern.',
  'splice.howBtn': 'Kassette beschriften',
  'splice.fromBottom': 'Kassetten zählen von unten: Kassette 1 liegt ganz unten. Kassette antippen zum Öffnen.',
  'splice.top': 'Oben im Stapel',
  'splice.topLast': 'letzte Kassette',
  'splice.bottom': 'Unten im Stapel',
  'splice.bottomFirst': 'Kassette 1',
  'splice.cassette': 'Kassette {n}',
  'splice.open': 'geöffnet',
  'splice.twoFloors': 'zwei Etagen auf einer Kassette',
  'splice.empty': 'Keine Wohnungen konfiguriert. Der Spleißplan entsteht nach der Gebäudekonfiguration.',
  'splice.help.title': 'Kassette beschriften',
  'splice.help.r1b': 'Kassetten von unten.',
  'splice.help.r1': ' Kassette 1 ganz unten im Stapel. Scharniere oben an der Kassette, Spleiße von oben 1, 2, 3.',
  'splice.help.r2b': 'Ein Aufkleber pro Spleiß',
  'splice.help.r2': ', Format Etage-Wohnung, z. B. 001-004.',
  'splice.help.r3b': '3 Ziffern, Bindestrich, 3 Ziffern.',
  'splice.help.r3': ' EG = 000, OG.1 = 001, OG.4 = 004, Keller = 099, WE4 = 004.',
  'splice.help.r4b': 'Nummer aus dem Lageplan:',
  'splice.help.r4': ' HH-L im OG.1 hat WE4 und WE5, nicht WE1 und WE2.',
  'splice.help.r5b': 'Ohne Gebäudecode',
  'splice.help.r5': ' auf dem Aufkleber. Der graue Zusatz (z. B. „HH-L WE4") steht nur auf dem Bildschirm.',
  'splice.help.good': 'RICHTIG',
  'splice.help.bad': 'FALSCH',
  'apl.cableFlats': 'Die Kabel aus den Wohnungen kommen von unten rechts.',
  'apl.cableNe3': 'NE3 kommt von unten links.',
  'apl.cableFromStreet': 'von der Straße',
  'apl.cableFromFlats': 'aus den|Wohnungen',
  'apl.cableAria': 'APL-Schema: NE3 unten links, Kabel aus den Wohnungen unten rechts',
  // v82 (MONIT 2026-10-04_1357, R3 + Zusatz HQ, Regel 4): Ablehnungen beim Speichern von Lageplan und Konfiguration.
  // N4 (MONIT 2026-10-04_1646 Z5): Ablehnung für Techniker ergänzt um „Die Änderung kann der Admin vornehmen."
  'err.we_numbers_shift': 'Diese Änderung würde die Nummern von Wohnungen verschieben, die schon Fotos haben: {list}. So eine Änderung wird nicht gespeichert, damit Fotos und Aufkleber übereinstimmen. Die Änderung kann der Admin vornehmen.',
  'err.we_numbers_shift_generic': 'Diese Änderung würde die Nummern von Wohnungen verschieben, die schon Fotos haben. So eine Änderung wird nicht gespeichert. Die Änderung kann der Admin vornehmen.',
  'err.we_numbers_shift_clear_admin': 'Das Leeren dieses Gebäudeteils würde die Nummern von Wohnungen verschieben, die schon Fotos haben: {list}. Das ließe sich nicht rückgängig machen, deshalb wurde „Alles löschen" nicht ausgeführt. Reduziere zuerst die Konfiguration dieses Gebäudeteils auf 0 Wohnungen und speichere (mit Umnummerierung), danach „Alles löschen".',
  'err.we_numbers_shift_clear_admin_generic': 'Das Leeren dieses Gebäudeteils würde die Nummern von Wohnungen verschieben, die schon Fotos haben. Das ließe sich nicht rückgängig machen, deshalb wurde „Alles löschen" nicht ausgeführt. Reduziere zuerst die Konfiguration dieses Gebäudeteils auf 0 Wohnungen und speichere (mit Umnummerierung), danach „Alles löschen".',
  'err.plan_hof_admin_only': 'Einen neuen Hof fügt nur der Admin hinzu.',
  'splice.loadFailed': 'Konfiguration konnte nicht geladen werden. Adresse einmal mit Empfang öffnen, danach funktioniert der Plan ohne Netz.',
  // N4 (MONIT 2026-10-04_1646): Wohnungen umnummerieren (Admin): Vorschau ohne Speichern, Zusammenfassung, Stand der Adresse.
  'rn.title': 'Wohnungen umnummerieren',
  'rn.kicker': 'Vorschau, nichts gespeichert',
  'rn.intro.config': 'Diese Änderung verschiebt die Nummern von Wohnungen, die schon Fotos haben. Es wird nichts gespeichert, bevor du bestätigst.',
  'rn.intro.align': 'Die Dateinamen tragen alte Wohnungsnummern. Die Umnummerierung passt sie an den Lageplan an. Es wird nichts gespeichert, bevor du bestätigst.',
  'rn.intro.undo': 'Rückgängig stellt die Nummern und Dateinamen vor der letzten Umnummerierung und den vorherigen Plan oder die vorherige Konfiguration wieder her.',
  'rn.filesTitle': 'Dateien: alte Nummer → neue',
  'rn.files': { one: '1 Datei', other: '{n} Dateien' },
  'rn.archived': { one: '1 archiviert', other: '{n} archiviert' },
  'rn.onedrive': '{n} in OneDrive',
  'rn.pdf': 'PDF Erklärung',
  'rn.total': 'Gesamt: {files} · OneDrive: {od} · PDF: {pdf}',
  'rn.noFiles': 'Kein Dateiname ändert sich.',
  'rn.stickersTitle': 'APL-Aufkleber zum Umkleben',
  'rn.stickersNone': 'Kein Aufkleber im APL ändert sich.',
  'rn.cassetteMove': 'Kassette {a} → {b}',
  'rn.cassette': 'Kassette {a}',
  'rn.stickerNew': 'neuer Spleiß',
  'rn.stickerRemoved': 'Spleiß entfällt',
  'rn.stickersMoved': { one: '1 Spleiß wechselt die Kassette ohne neuen Aufkleber (Details im Spleißplan).', other: '{n} Spleiße wechseln die Kassette ohne neuen Aufkleber (Details im Spleißplan).' },
  'rn.splicesTotal': 'Spleiße: {a} → {b} · Kassetten: {c} → {d}',
  'rn.skipped': { one: '1 Datei hat einen Namen ohne Wohnungsnummer und bleibt unverändert.', other: '{n} Dateien haben einen Namen ohne Wohnungsnummer und bleiben unverändert.' },
  'rn.vpsMissing': { one: '1 Datei fehlt auf dem VPS (der Name in der Datenbank ändert sich trotzdem).', other: '{n} Dateien fehlen auf dem VPS (die Namen in der Datenbank ändern sich trotzdem).' },
  'rn.blocked': 'Umnummerierung gesperrt: {why}. Es wird nichts gespeichert.',
  'rn.block.cycle': 'zwei Dateien würden ihre Namen tauschen',
  'rn.block.path_outside_root': 'Datei außerhalb des Fotoordners',
  'rn.block.name_taken': 'der neue Name ist schon von einem anderen Foto belegt',
  'rn.block.target_exists': 'eine Datei mit dem neuen Namen liegt schon auf dem VPS',
  'rn.noUndo': 'Dieser Vorgang kann nicht rückgängig gemacht werden: „Alles löschen" entfernt die Fotos dieses Gebäudeteils.',
  'rn.lockInfo': 'Während der Umnummerierung warten Fotos dieser Adresse in der Warteschlange des Handys (wenige Sekunden).',
  'rn.confirm.config': 'Umnummerieren und speichern',
  'rn.confirm.align': 'Umnummerieren',
  'rn.confirm.undo': 'Umnummerierung rückgängig',
  'rn.busy': 'Wird umnummeriert…',
  'rn.changed': 'In der Zwischenzeit haben sich Fotos oder der Plan geändert. Bitte die neue Vorschau prüfen.',
  'rn.failed': 'Umnummerierung abgebrochen, die Namen sind wieder wie vorher. Nichts ist verloren.',
  'rn.failedAttention': 'Umnummerierung abgebrochen, ein Teil der Namen konnte nicht zurückgesetzt werden. Die vollständige Liste steht im Protokoll, bitte an Martin melden.',
  'rn.addressBusy': 'Auf dieser Adresse läuft gerade ein anderer Vorgang. Bitte gleich nochmal versuchen.',
  'rn.sum.title': 'Umnummeriert',
  'rn.sum.titleUndo': 'Umnummerierung rückgängig gemacht',
  'rn.sum.files': { one: 'Umbenannt: 1 Datei', other: 'Umbenannt: {n} Dateien' },
  'rn.sum.stickersHint': 'Zeige diese Liste dem Techniker am APL (Screenshot möglich).',
  'rn.sum.odRunning': 'OneDrive: Dateien werden verschoben…',
  'rn.sum.odDone': 'OneDrive: fertig',
  'rn.sum.odNone': 'OneDrive: nichts zu verschieben',
  'rn.sum.odPending': { one: 'OneDrive: 1 Datei wartet, neuer Versuch beim nächsten Sync', other: 'OneDrive: {n} Dateien warten, neuer Versuch beim nächsten Sync' },
  'rn.sum.done': 'Fertig',
  'rn.st.title': 'Wohnungsnummern',
  'rn.st.alignOk': 'Dateinamen stimmen mit dem Lageplan überein.',
  'rn.st.alignTodo': { one: '1 Datei trägt eine alte Wohnungsnummer.', other: '{n} Dateien tragen eine alte Wohnungsnummer.' },
  'rn.st.alignBtn': 'Vorschau zeigen',
  'rn.st.last': 'Letzte Umnummerierung',
  'rn.st.none': 'Auf dieser Adresse wurde noch nicht umnummeriert.',
  'rn.st.open': 'Zusammenfassung',
  'rn.st.by': '{who} · {when}',
  'rn.kind.config': 'Konfiguration geändert',
  'rn.kind.plan': 'Lageplan geändert',
  'rn.kind.clear': 'Alles löschen',
  'rn.kind.align': 'Namensabgleich',
  'rn.kind.undo': 'Rückgängig',
  'rn.status.done': 'erledigt',
  'rn.status.undone': 'rückgängig gemacht',
  'rn.status.failed_reverted': 'abgebrochen, zurückgesetzt',
  'rn.status.needs_attention': 'abgebrochen, bitte prüfen',
  'rn.status.running': 'läuft',
  'rn.undoNo.no_op': 'Kein Vorgang zum Rückgängigmachen.',
  'rn.undoNo.last_is_undo': 'Der letzte Vorgang ist schon ein Rückgängig.',
  'rn.undoNo.clear_not_undoable': '„Alles löschen" kann nicht rückgängig gemacht werden.',
  'rn.undoNo.not_done': 'Der Vorgang wurde nicht abgeschlossen.',
  'rn.undoNo.onedrive_running': 'Zuerst muss das Verschieben in OneDrive fertig sein.',
  'rn.undoNo.changed_since': 'Nach der Umnummerierung wurde der Plan oder die Konfiguration geändert.',
  'rn.undoNo.section_has_photos': 'Der Gebäudeteil hat schon neue Fotos.',
  'rn.undoNo.not_last': 'Nur der letzte Vorgang kann rückgängig gemacht werden.',
  'rn.undoNo.no_before_state': 'Kein gespeicherter Stand vor dem Vorgang.',
  'rn.adminOnly': 'Die Umnummerierung von Wohnungen macht nur der Admin.',
  'plan.renumber': 'Wohnungsnummern',
  // ─── Auskundung E1 (MONIT 2026-10-10_1515): Liste der AK-Termine ───
  'ak.title': 'Auskundung',
  'ak.allWeek': 'Ganze Woche',
  'ak.today': 'heute',
  'ak.pickDay': 'Wochentag',
  'ak.pickWeek': 'Woche (KW)',
  'ak.kunde': 'Kunde: {k}',
  'ak.taskNr': 'AK_Task-Nr',
  'ak.copy': 'Kopieren',
  'ak.copied': 'Kopiert',
  'ak.copyAria': 'Task-Nummer {tsk} kopieren',
  'ak.copiedToast': '{tsk} kopiert. Öffne Zinier und füge die Nummer in die Task-Suche ein.',
  'ak.copyFallback': 'Zwischenablage nicht verfügbar: Die Nummer {tsk} ist markiert, kopiere sie von Hand.',
  'ak.storniert': 'Task im FSM storniert',
  'ak.info': 'AK Info',
  'ak.infoEmpty': 'keine Hinweise vom Büro',
  'ak.akpStatus': 'AKP Status',
  'ak.statusNone': 'keiner',
  'ak.markConfig': 'Konfiguration',
  'ak.markPhotos': 'Eingangsfotos {x}/{y}',
  'ak.markStatus': 'Status',
  'ak.terms': { one: '{n} Termin', other: '{n} Termine' },
  'ak.noTerms': 'Keine Auskundung-Termine an diesem Tag.',
  'ak.noTermsWeek': 'Keine Auskundung-Termine in dieser Woche.',
  'ak.loadFailed': 'Die Auskundung-Termine konnten nicht geladen werden.',
  'ak.backToList': 'Zurück zur Auskundung-Liste',
  // E2 (MONIT 2026-10-10_1735): Konfiguration durch AK; Fotos und Notiz weiterhin ab der nächsten Version.
  'ak.notOnListTitle': 'Adresse nicht auf deiner Auskundung-Liste',
  'ak.notOnListText': 'Die Konfiguration speicherst du nur für Adressen aus deinen Auskundung-Terminen. Wenn der Termin da ist und die Adresse sich nicht öffnet, ruf im Büro an.',
  'ak.photosNextVersion': 'Fotos für Auskundung-Techniker kommen in der nächsten Version. Speichere jetzt die Gebäudekonfiguration.',
  'ak.configSavedToList': 'Konfiguration gespeichert. Zurück zur Auskundung-Liste.',
  'ak.configSavedToPlan': 'Konfiguration gespeichert. Konfiguriere den nächsten Eingang im Plan.',
  'ak.tabTerms': 'Termine',
  // E3 (MONIT 2026-10-10_2340): Fotos der Auskundung (Bildschirm AK-3, Präfix AK_).
  'ak.ph.title': 'Eingangsfotos',
  'ak.ph.lead': 'Jeder Eingang: Gebäude von außen und Klingelanlage. Pflicht für den Abschluss des Termins.',
  'ak.ph.prefix': 'Dateien aus der Auskundung erhalten das Präfix',
  'ak.ph.count': 'Fotos: {x} von {y}',
  'ak.ph.all': 'Alle Slots',
  'ak.ph.open': 'Eingangsfotos öffnen',
  'ak.ph.unconfigured': 'Eingang noch nicht konfiguriert. Das Foto landet nach dem Speichern der Konfiguration im Slot.',
  'ak.ph.loadFailed': 'Eingangsfotos konnten nicht geladen werden.',
  'err.ak_next_version': 'Diese Funktion kommt für Auskundung-Techniker in der nächsten Version.',
  'err.ak_not_on_list': 'Diese Adresse steht nicht auf deiner Auskundung-Liste.',
  // E5 (MONIT 2026-10-11_0125): Admin, Modus MO / AK (Schalter im Kopf), AK-Karte des Admins, „Jetzt senden“ der AK-Fotos.
  'ak.adm.toAk': 'Auf Auskundung-Termine umschalten',
  'ak.adm.toMo': 'Auf Montage-Termine umschalten',
  'ak.adm.allAkTeams': 'Alle AK-Teams',
  'ak.adm.noAkTeam': 'Ohne AK-Team',
  'ak.adm.teamAria': 'Auskundung-Team',
  'ak.adm.sendNow': 'Jetzt senden',
  'ak.adm.sendNowTitle': 'Auskundung-Fotos dieser Adresse auf OneDrive senden (derselbe Sync wie im MO-Modus)',
  'ak.infoN': 'AK Info · {n}',
  // E4 (MONIT 2026-10-11_1415): status terminu AK (ekran AK-5), notatka AK odblokowana
  'ak.notePrefixHint': 'Die Notiz geht mit dem Kennzeichen „AK:“ ans Büro.',
  'ak.st.button': 'Terminstatus',
  'ak.st.change': 'Status ändern',
  'ak.st.title': 'Ergebnis Auskundung',
  'ak.st.qHeld': 'Hat der Termin stattgefunden?',
  'ak.st.yes': 'Ja',
  'ak.st.no': 'Nein',
  'ak.st.qSign': 'Liegt die Unterschrift des Kunden vor?',
  'ak.st.signYes': 'Unterschrift liegt vor',
  'ak.st.signNo': 'Keine Unterschrift',
  'ak.st.reason': 'Grund',
  'ak.st.r.kunde_nicht_da': 'Kunde nicht da',
  'ak.st.r.kein_zugang': 'Kein Zugang',
  'ak.st.r.sonstiges': 'Sonstiges',
  'ak.st.notePh': 'Notiz (optional)',
  'ak.st.willSet': 'AKP Status wird gesetzt auf',
  'ak.st.hintDone': 'Ohne Unterschrift lautet der Status „Termin erledigt ohne Unterschrift“. Büro- und FSM-Status ändert der Techniker nicht.',
  'ak.st.hintNotDone': 'Grund und Notiz gehen mit dem Kennzeichen AK in die Techniker-Bemerkung.',
  'ak.st.hintNoFsm': 'Der Termin hatte keinen FSM-Task: In die Techniker-Bemerkung kommt der Vermerk „Termin durchgeführt ohne FSM-Task“.',
  'ak.st.save': 'Speichern',
  'ak.st.saving': 'Speichere…',
  'ak.st.saved': 'Status gespeichert: {label}',
  'ak.st.savedNoteFail': 'Status gespeichert, aber die Notiz kam nicht in Airtable an. Bitte in Info nachtragen oder das Büro anrufen.',
  'ak.st.locked': 'Status setzt das Büro / FSM',
  'ak.st.lockedConflict': 'Büro / FSM hat bereits den Status „{label}“ gesetzt. Nichts gespeichert.',
  'ak.st.failed': 'Status konnte nicht gespeichert werden. Bitte erneut versuchen.',
  'ak.st.offline': 'Ohne Internet wird der Status nicht gespeichert. Bitte erneut versuchen, sobald Empfang da ist.',
  'ak.st.by': 'gesetzt von: {by} · {at}',
  'ak.st.resConflict': 'letzter Versuch abgelehnt: Büro- / FSM-Status',
  'ak.st.resError': 'letzter Schreibversuch in Airtable fehlgeschlagen',
  'ak.st.noteFailed': 'Notiz kam nicht in Airtable an',
  'sync.ak.none': 'AK: keine Auskundung-Fotos zu senden',
  'sync.ak.open': '⏳ AK: angehalten bis zum Terminabschluss (Konfiguration {cfg} · Eingangsfotos {x}/{y} · Status {st})',
  'sync.ak.renumber': '⏳ AK: angehalten, Wohnungen werden umnummeriert',
  'sync.ak.failedMarks': 'AK ⚠ Terminstand konnte nicht geprüft werden',
  'sync.ak.withErrors': 'AK ⚠ kopiert {synced}/{total}, Fehler: {errs}',
  'sync.ak.copied': '✅ AK: kopiert {synced}/{total}',
  'sync.ak.allDone': '✅ AK: alles bereits auf OneDrive',
};
